<div
  class="page-content shop-page"
  (scroll)="onScroll($event)"
  [class.cart-dropdown-open]="is_show_cart"
>
  <div
    class="page-content-wrp"
    [class.no_margin]="!offer_service.is_show_cart_offer"
  >
    <div class="shop-header-main" id="shop-header-main">
      <div class="shop-page-header" id="shop-page-header">
        <div class="shop-header-wrp d-flex align-items-center">
          <div
            class="shop-profile-img"
            (click)="go_to_home()"
            *ngIf="helper.website_data.detail.site_logo"
          >
            <span
              ><img src="{{ helper.website_data.detail.site_logo }}" alt=""
            /></span>
          </div>
          <!-- <div class="delivery-options-list" [class.active]="is_show_header_error"> -->
          <div class="delivery-options-list">
            <div
              class="modal-backdrop modal-backdrop-custom fade show"
              *ngIf="is_show_header_popup"
            ></div>
            <div
              class="deli-optiond-wrp d-flex align-items-center justify-content-center"
              (click)="show_header_popup()"
            >
              <ul class="d-flex align-items-center">
                <li>
                  <svg
                    *ngIf="
                      !helper.common_data.cart_data.ipickup_delivery &&
                      !helper.common_data.cart_data.is_catering
                    "
                    width="23"
                    height="23"
                    viewBox="0 0 23 23"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18.0038 6.63192C18.0038 5.58961 17.1511 4.73682 16.1087 4.73682H13.2661V6.63192H16.1087V9.14292L12.8113 13.2648H9.4759V8.52701H5.68571C3.59162 8.52701 1.89551 10.2231 1.89551 12.3172V15.1599H3.79061C3.79061 16.7328 5.06032 18.0025 6.63325 18.0025C8.20619 18.0025 9.4759 16.7328 9.4759 15.1599H13.7209L18.0038 9.80621V6.63192ZM6.63325 16.1074C6.1121 16.1074 5.68571 15.681 5.68571 15.1599H7.5808C7.5808 15.681 7.15441 16.1074 6.63325 16.1074Z"
                    />
                    <path
                      d="M4.73877 5.68408H9.47652V7.57918H4.73877V5.68408ZM18.0045 12.3169C16.4315 12.3169 15.1618 13.5866 15.1618 15.1596C15.1618 16.7325 16.4315 18.0022 18.0045 18.0022C19.5774 18.0022 20.8471 16.7325 20.8471 15.1596C20.8471 13.5866 19.5774 12.3169 18.0045 12.3169ZM18.0045 16.1071C17.4833 16.1071 17.0569 15.6807 17.0569 15.1596C17.0569 14.6384 17.4833 14.212 18.0045 14.212C18.5256 14.212 18.952 14.6384 18.952 15.1596C18.952 15.6807 18.5256 16.1071 18.0045 16.1071Z"
                    />
                  </svg>
                  <svg
                    width="23"
                    height="23"
                    viewBox="0 0 38 31"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    *ngIf="
                      !helper.common_data.cart_data.ipickup_delivery &&
                      helper.common_data.cart_data.is_catering
                    "
                  >
                    <path
                      d="M1 19.0554H37M34.9692 19.0554C34.9692 10.2363 27.82 3.08618 19 3.08618C10.18 3.08618 3.03077 10.2363 3.03077 19.0554"
                      stroke="#DDD1BA"
                      stroke-width="1.84615"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M12.3494 6.96492C10.6995 8.04127 9.33587 9.50244 8.3759 11.2227C7.41593 12.9429 6.88838 14.8707 6.83866 16.84M19.0002 3.08615V1M19.8679 25.2585C24.666 25.2003 25.2808 25 34.1525 22.7477C34.711 22.6065 35.1254 22.8926 35.2473 23.2175C35.3719 23.5498 35.3211 24.1388 34.5633 24.3354C33.0679 24.7231 23.7448 29.0246 21.6217 29.0246C19.4987 29.0246 13.314 28.5631 10.9879 28.5631C8.66174 28.5631 5.94789 30.04 5.94789 30.04C4.08328 28.3046 2.90174 25.4246 2.58789 22.3046H25.6279C26.5787 22.3046 26.8833 23.6338 26.071 24.0031C24.8664 24.5505 22.8217 25.2585 19.8679 25.2585Z"
                      stroke="#DDD1BA"
                      stroke-width="1.84615"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <svg
                    *ngIf="
                      helper.common_data.cart_data.ipickup_delivery &&
                      !helper.common_data.cart_data.is_order_pay
                    "
                    width="11"
                    height="17"
                    viewBox="0 0 11 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.53877 3.01781C7.37181 3.01781 8.04768 2.34194 8.04768 1.5089C8.04768 0.675863 7.37181 0 6.53877 0C5.70573 0 5.02987 0.675863 5.02987 1.5089C5.02987 2.34194 5.70573 3.01781 6.53877 3.01781ZM9.50943 7.70484L8.77698 7.3339L8.47206 6.4097C8.00996 5.00768 6.7211 4.02689 5.25935 4.02374C4.12767 4.0206 3.5021 4.34124 2.32642 4.81592C1.64741 5.08941 1.091 5.60809 0.764073 6.26824L0.553455 6.69576C0.308259 7.19244 0.506302 7.796 0.999839 8.04434C1.49023 8.29268 2.08751 8.0915 2.33585 7.59482L2.54647 7.16729C2.65649 6.94725 2.83882 6.77435 3.06515 6.68319L3.90762 6.34368L3.4298 8.25182C3.26634 8.90568 3.44238 9.6004 3.89819 10.1002L5.78118 12.1561C6.00751 12.4044 6.16784 12.7031 6.24957 13.0269L6.82484 15.3311C6.96001 15.8686 7.50699 16.1987 8.04453 16.0635C8.58208 15.9284 8.91216 15.3814 8.77698 14.8438L8.07911 12.0461C7.99738 11.7223 7.83706 11.4205 7.61072 11.1753L6.18041 9.61298L6.7211 7.45336L6.894 7.97204C7.0606 8.47816 7.41897 8.89625 7.8905 9.13516L8.62295 9.50609C9.11334 9.75444 9.71062 9.55325 9.95896 9.05657C10.201 8.56303 10.003 7.95318 9.50943 7.70484ZM2.31384 12.1278C2.21325 12.3824 2.06236 12.6119 1.86746 12.8037L0.295684 14.3786C-0.0972594 14.7715 -0.0972594 15.4097 0.295684 15.8026C0.688628 16.1956 1.32362 16.1956 1.71657 15.8026L3.58384 13.9354C3.77559 13.7436 3.92648 13.5141 4.03022 13.2595L4.4546 12.197C2.71622 10.3014 3.23805 10.883 2.96456 10.5089L2.31384 12.1278Z"
                    />
                  </svg>
                  <svg
                    *ngIf="
                      helper.common_data.cart_data.ipickup_delivery &&
                      helper.common_data.cart_data.is_order_pay
                    "
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.56732 18.3211L3.55187 18.4346H3.6664H5.49974H5.58714L5.59884 18.348L6.20589 13.8513H15.7936L16.4006 18.348L16.4123 18.4346H16.4997H18.3331H18.4473L18.4322 18.3214L17.3473 10.1846H19.2497C19.5874 10.1846 19.8588 10.0474 20.0533 9.77627C20.246 9.50767 20.3013 9.20962 20.2173 8.89044L20.2173 8.89043L20.2167 8.88848L18.9105 4.30514L18.9105 4.30514L18.9099 4.30314C18.8433 4.08661 18.7254 3.90877 18.556 3.77321C18.3838 3.63546 18.1778 3.56797 17.9435 3.56797H4.05599C3.82165 3.56797 3.61571 3.63546 3.44352 3.77322C3.27407 3.90877 3.1562 4.08661 3.08957 4.30314L3.08955 4.30314L3.08898 4.30514L1.78273 8.88848L1.78272 8.88847L1.78224 8.89025C1.69754 9.20956 1.75282 9.50775 1.94625 9.7764C2.14136 10.0474 2.41257 10.1846 2.74974 10.1846H4.67479L3.56732 18.3211ZM17.9029 8.1513H4.09765L4.8414 5.6013H17.1804L17.9029 8.1513ZM6.48526 11.818L6.70984 10.1846H15.3115L15.5156 11.818H6.48526Z"
                      stroke-width="0.2"
                    />
                  </svg>
                  <span
                    *ngIf="
                      helper.common_data.cart_data.ipickup_delivery &&
                      helper.common_data.cart_data.is_order_pay
                    "
                    >{{ helper.button.table_order | translate }}</span
                  >
                  <span
                    *ngIf="
                      helper.common_data.cart_data.ipickup_delivery &&
                      !helper.common_data.cart_data.is_order_pay
                    "
                    >{{ helper.button.en_click_collect | translate }}</span
                  >
                  <span
                    *ngIf="
                      !helper.common_data.cart_data.ipickup_delivery &&
                      !helper.common_data.cart_data.is_catering
                    "
                    >{{ helper.button.en_livraison | translate }}</span
                  >
                  <span
                    *ngIf="
                      !helper.common_data.cart_data.ipickup_delivery &&
                      helper.common_data.cart_data.is_catering
                    "
                    >{{ helper.button.catering | translate }}</span
                  >
                </li>
                <li *ngIf="!helper.common_data.cart_data.is_order_pay">
                  <svg
                    *ngIf="!helper.common_data.cart_data.is_schedule_order"
                    width="11"
                    height="15"
                    viewBox="0 0 11 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2.46335 14.8327C2.35463 14.7868 2.26429 14.706 2.20657 14.6031C2.14886 14.5002 2.12705 14.3809 2.1446 14.2643L3.11148 7.96894H0.545538C0.46419 7.97113 0.383427 7.9546 0.309479 7.92063C0.235532 7.88666 0.170377 7.83615 0.119042 7.77301C0.0677068 7.70987 0.0315635 7.63578 0.0134009 7.55645C-0.00476179 7.47713 -0.00445822 7.39469 0.014288 7.3155L1.60804 0.409252C1.63608 0.290396 1.70422 0.18483 1.80098 0.110325C1.89774 0.0358204 2.01721 -0.00307379 2.13929 0.000189875H7.45179C7.53115 -7.99851e-05 7.60957 0.0174362 7.68128 0.0514514C7.75299 0.0854666 7.81616 0.135116 7.86616 0.196752C7.91687 0.259085 7.95278 0.332107 7.97118 0.410324C7.98958 0.48854 7.99001 0.569912 7.97241 0.648315L7.05335 4.78144H9.57679C9.67636 4.78124 9.77397 4.80903 9.85851 4.86163C9.94305 4.91423 10.0111 4.98953 10.0549 5.07894C10.093 5.16476 10.1076 5.25913 10.0974 5.35245C10.0871 5.44577 10.0523 5.5347 9.99648 5.61019L3.09023 14.6414C3.04355 14.7106 2.98123 14.7679 2.90831 14.8085C2.8354 14.8491 2.75394 14.8719 2.67054 14.8752C2.59945 14.8739 2.52922 14.8595 2.46335 14.8327Z"
                    />
                  </svg>
                  <svg
                    *ngIf="helper.common_data.cart_data.is_schedule_order"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7 11H9V13H7V11ZM7 15H9V17H7V15ZM11 11H13V13H11V11ZM11 15H13V17H11V15ZM15 11H17V13H15V11ZM15 15H17V17H15V15Z"
                    ></path>
                    <path
                      d="M5 22H19C20.103 22 21 21.103 21 20V6C21 4.897 20.103 4 19 4H17V2H15V4H9V2H7V4H5C3.897 4 3 4.897 3 6V20C3 21.103 3.897 22 5 22ZM19 8L19.001 20H5V8H19Z"
                    ></path>
                  </svg>

                  <span
                    *ngIf="!helper.common_data.cart_data.is_schedule_order"
                    >{{ helper.button.des_que_possible | translate }}</span
                  >
                  <span *ngIf="helper.common_data.cart_data.is_schedule_order"
                    >{{ delivery_setting_service.clicked_date }},
                    {{ delivery_setting_service.schedule_time }}</span
                  >
                </li>

                <li
                  *ngIf="
                    !helper.common_data.cart_data.ipickup_delivery ||
                    helper.common_data.cart_data.is_order_pay
                  "
                  class="long-add"
                >
                  <svg
                    class="table_no_svg"
                    width="12"
                    height="14"
                    viewBox="0 0 12 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6 0C2.85 0 0 2.29094 0 5.83407C0 8.09656 1.8375 10.7575 5.505 13.8239C5.79 14.0587 6.2175 14.0587 6.5025 13.8239C10.1625 10.7575 12 8.09656 12 5.83407C12 2.29094 9.15 0 6 0ZM6 7.11473C5.175 7.11473 4.5 6.4744 4.5 5.69178C4.5 4.90916 5.175 4.26884 6 4.26884C6.825 4.26884 7.5 4.90916 7.5 5.69178C7.5 6.4744 6.825 7.11473 6 7.11473Z"
                    />
                  </svg>
                  <span *ngIf="!helper.common_data.cart_data.is_order_pay">{{
                    helper.common_data.cart_data.destination_address.address
                  }}</span>
                  <span
                    class="table_no"
                    *ngIf="helper.common_data.cart_data.is_order_pay"
                    >{{ helper.title.table | translate }}
                    {{ helper.common_data.cart_data.table_no }}</span
                  >
                </li>
              </ul>
            </div>

            <!-- You will have to add the "show" class... And when user will close the dropdown then "hide" class will be added autometically -->

            <div
              class="deli-list-dropdown"
              (clickOutside)="close_header_popup()"
              *ngIf="is_show_header_popup"
            >
              <button
                type="button"
                class="close pull-right"
                (click)="close_header_popup()"
              >
                <span aria-hidden="true"
                  ><svg
                    width="14"
                    height="15"
                    viewBox="0 0 14 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.641964 4.44674C0.27079 4.07556 0.0852035 3.64252 0.0852036 3.14762C0.0852039 2.65272 0.270791 2.21969 0.641965 1.84851C1.01314 1.47734 1.43844 1.29948 1.91788 1.31495C2.39731 1.33042 2.82261 1.52374 3.19379 1.89491L12.6355 11.3367C13.0067 11.7078 13.1923 12.1409 13.1923 12.6358C13.2078 13.1152 13.0299 13.5405 12.6587 13.9117C12.2876 14.2829 11.8545 14.4684 11.3596 14.4684C10.8802 14.453 10.4549 14.2597 10.0837 13.8885L0.641964 4.44674ZM0.804354 13.6565C0.371317 13.2235 0.147065 12.7208 0.1316 12.1486C0.1316 11.5918 0.348119 11.0969 0.781156 10.6639L9.82853 1.61653C10.2616 1.18349 10.7642 0.974707 11.3364 0.990173C11.9087 1.00564 12.4113 1.22989 12.8443 1.66293C13.2928 2.11143 13.5093 2.60633 13.4939 3.14763C13.4939 3.70439 13.2774 4.19929 12.8443 4.63232L3.79695 13.6797C3.36391 14.1127 2.86901 14.3293 2.31225 14.3293C1.75549 14.3293 1.25286 14.105 0.804354 13.6565Z"
                    /></svg
                ></span>
              </button>
              <div class="modal-content d-l-drop-mob">
                <button
                  type="button"
                  class="close with-name pull-right d-flex align-items-center"
                  aria-label="Close"
                  (click)="close_header_popup()"
                >
                  <span aria-hidden="true">
                    <label>{{ helper.button.fermer | translate }}</label>
                    <svg
                      width="30"
                      height="30"
                      viewBox="0 0 30 30"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M15 3C12.6266 3 10.3066 3.70379 8.33316 5.02236C6.35977 6.34094 4.8217 8.21508 3.91345 10.4078C3.0052 12.6005 2.76756 15.0133 3.23058 17.3411C3.6936 19.6689 4.83649 21.807 6.51472 23.4853C8.19295 25.1635 10.3311 26.3064 12.6589 26.7694C14.9867 27.2324 17.3995 26.9948 19.5922 26.0865C21.7849 25.1783 23.6591 23.6402 24.9776 21.6668C26.2962 19.6934 27 17.3734 27 15C27 13.4241 26.6896 11.8637 26.0866 10.4078C25.4835 8.95189 24.5996 7.62902 23.4853 6.51472C22.371 5.40041 21.0481 4.5165 19.5922 3.91345C18.1363 3.31039 16.5759 3 15 3ZM18.252 16.548C18.3645 16.6596 18.4538 16.7923 18.5147 16.9385C18.5756 17.0847 18.607 17.2416 18.607 17.4C18.607 17.5584 18.5756 17.7153 18.5147 17.8615C18.4538 18.0077 18.3645 18.1404 18.252 18.252C18.1404 18.3645 18.0077 18.4537 17.8615 18.5147C17.7153 18.5756 17.5584 18.607 17.4 18.607C17.2416 18.607 17.0847 18.5756 16.9385 18.5147C16.7923 18.4537 16.6596 18.3645 16.548 18.252L15 16.692L13.452 18.252C13.3404 18.3645 13.2077 18.4537 13.0615 18.5147C12.9153 18.5756 12.7584 18.607 12.6 18.607C12.4416 18.607 12.2847 18.5756 12.1385 18.5147C11.9923 18.4537 11.8596 18.3645 11.748 18.252C11.6355 18.1404 11.5463 18.0077 11.4853 17.8615C11.4244 17.7153 11.393 17.5584 11.393 17.4C11.393 17.2416 11.4244 17.0847 11.4853 16.9385C11.5463 16.7923 11.6355 16.6596 11.748 16.548L13.308 15L11.748 13.452C11.522 13.226 11.3951 12.9196 11.3951 12.6C11.3951 12.2804 11.522 11.974 11.748 11.748C11.974 11.522 12.2804 11.3951 12.6 11.3951C12.9196 11.3951 13.226 11.522 13.452 11.748L15 13.308L16.548 11.748C16.774 11.522 17.0804 11.3951 17.4 11.3951C17.7196 11.3951 18.026 11.522 18.252 11.748C18.478 11.974 18.6049 12.2804 18.6049 12.6C18.6049 12.9196 18.478 13.226 18.252 13.452L16.692 15L18.252 16.548Z"
                      />
                    </svg>
                  </span>
                </button>
              </div>
              <div class="d-l-row d-flex align-items-top">
                <div class="d-l-block">
                  <div class="block-title">
                    <h3>
                      {{ helper.title.quel_type_de_commande | translate }}
                    </h3>
                  </div>
                  <div class="deli-type-btn">
                    <div
                      class="d-alert-msg"
                      *ngIf="
                        current_store.is_delivery_possible == false &&
                        current_store.is_pickup_possible == true
                      "
                    >
                      <p>{{ helper.text.d_alert_msg11 | translate }}</p>
                    </div>
                    <button
                      *ngIf="current_store.order_type !== 1"
                      class="primary-btn"
                      [disabled]="current_store.is_delivery_possible == false"
                      (click)="select_delivery_option(false, false)"
                      [class.active]="
                        !helper.common_data.cart_data.ipickup_delivery &&
                        !helper.common_data.cart_data.is_catering
                      "
                    >
                      <span class="btn-mark">
                        <label
                          class="blue-tick"
                          *ngIf="
                            !helper.common_data.cart_data.ipickup_delivery &&
                            !helper.common_data.cart_data.is_catering
                          "
                        >
                          <svg
                            width="10"
                            height="9"
                            viewBox="0 0 10 9"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1.37549 4.08445L4.06834 7.67491L8.55642 1.3916"
                              stroke-width="1.61571"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </label>
                      </span>
                      <svg
                        width="23"
                        height="24"
                        viewBox="0 0 23 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M18.2626 7.1407C18.2626 6.0984 17.4098 5.24561 16.3675 5.24561H13.5249V7.1407H16.3675V9.65171L13.0701 13.7736H9.73469V9.0358H5.94449C3.85041 9.0358 2.1543 10.7319 2.1543 12.826V15.6686H4.0494C4.0494 17.2416 5.31911 18.5113 6.89204 18.5113C8.46498 18.5113 9.73469 17.2416 9.73469 15.6686H13.9797L18.2626 10.315V7.1407ZM6.89204 16.6162C6.37089 16.6162 5.94449 16.1898 5.94449 15.6686H7.83959C7.83959 16.1898 7.4132 16.6162 6.89204 16.6162Z"
                        />
                        <path
                          d="M4.99756 6.19287H9.73531V8.08797H4.99756V6.19287ZM18.2632 12.8257C16.6903 12.8257 15.4206 14.0954 15.4206 15.6684C15.4206 17.2413 16.6903 18.511 18.2632 18.511C19.8362 18.511 21.1059 17.2413 21.1059 15.6684C21.1059 14.0954 19.8362 12.8257 18.2632 12.8257ZM18.2632 16.6159C17.7421 16.6159 17.3157 16.1895 17.3157 15.6684C17.3157 15.1472 17.7421 14.7208 18.2632 14.7208C18.7844 14.7208 19.2108 15.1472 19.2108 15.6684C19.2108 16.1895 18.7844 16.6159 18.2632 16.6159Z"
                        />
                      </svg>
                      {{ helper.button.en_livraison | translate }}
                    </button>
                    <div
                      class="d-alert-msg"
                      *ngIf="
                        current_store.is_pickup_possible == false &&
                        current_store.is_delivery_possible == true
                      "
                    >
                      <p>{{ helper.text.d_alert_msg1 | translate }}</p>
                    </div>
                    <button
                      *ngIf="current_store.order_type !== 2"
                      class="primary-btn"
                      [disabled]="current_store.is_pickup_possible == false"
                      (click)="select_delivery_option(true, false)"
                      [class.active]="
                        helper.common_data.cart_data.ipickup_delivery
                      "
                    >
                      <span class="btn-mark">
                        <label
                          class="blue-tick"
                          *ngIf="helper.common_data.cart_data.ipickup_delivery"
                        >
                          <svg
                            width="10"
                            height="9"
                            viewBox="0 0 10 9"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1.37549 4.08445L4.06834 7.67491L8.55642 1.3916"
                              stroke-width="1.61571"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </label>
                      </span>
                      <svg
                        width="12"
                        height="19"
                        viewBox="0 0 12 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_1799_2484)">
                          <path
                            d="M7.80004 3.5625C8.79379 3.5625 9.60004 2.76465 9.60004 1.78125C9.60004 0.797852 8.79379 0 7.80004 0C6.80629 0 6.00004 0.797852 6.00004 1.78125C6.00004 2.76465 6.80629 3.5625 7.80004 3.5625ZM11.3438 9.09551L10.47 8.65762L10.1063 7.5666C9.55504 5.91152 8.01754 4.75371 6.27379 4.75C4.92379 4.74629 4.17754 5.1248 2.77504 5.68516C1.96504 6.00801 1.30129 6.62031 0.911289 7.39961L0.660039 7.9043C0.367539 8.49063 0.603789 9.20312 1.19254 9.49629C1.77754 9.78945 2.49004 9.55195 2.78629 8.96562L3.03754 8.46094C3.16879 8.20117 3.38629 7.99707 3.65629 7.88945L4.66129 7.48867L4.09129 9.74121C3.89629 10.5131 4.10629 11.3332 4.65004 11.9232L6.89629 14.3502C7.16629 14.6434 7.35754 14.9959 7.45504 15.3781L8.14129 18.0982C8.30254 18.7328 8.95504 19.1225 9.59629 18.9629C10.2375 18.8033 10.6313 18.1576 10.47 17.523L9.63754 14.2203C9.54004 13.8381 9.34879 13.4818 9.07879 13.1924L7.37254 11.348L8.01754 8.79863L8.22379 9.41094C8.42254 10.0084 8.85004 10.502 9.41254 10.784L10.2863 11.2219C10.8713 11.515 11.5838 11.2775 11.88 10.6912C12.1688 10.1086 11.9325 9.38867 11.3438 9.09551ZM2.76004 14.3168C2.64004 14.6174 2.46004 14.8883 2.22754 15.1146L0.352539 16.9738C-0.116211 17.4377 -0.116211 18.191 0.352539 18.6549C0.821289 19.1187 1.57879 19.1187 2.04754 18.6549L4.27504 16.4506C4.50379 16.2242 4.68379 15.9533 4.80754 15.6527L5.31379 14.3984C3.24004 12.1607 3.86254 12.8473 3.53629 12.4057L2.76004 14.3168Z"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_1799_2484">
                            <rect width="12" height="19" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                      {{ helper.button.en_click_collect | translate }}
                    </button>
                    <div
                      class="d-alert-msg"
                      *ngIf="
                        current_store.is_delivery_possible == false &&
                        current_store.is_pickup_possible == true
                      "
                    >
                      <p>{{ helper.text.d_alert_msg11 | translate }}</p>
                    </div>
                    <button
                      *ngIf="
                        current_store.order_type !== 1 &&
                        current_store.is_catering_active
                      "
                      class="primary-btn"
                      [disabled]="current_store.is_delivery_possible == false"
                      (click)="select_delivery_option(false, true)"
                      [class.active]="
                        !helper.common_data.cart_data.ipickup_delivery &&
                        helper.common_data.cart_data.is_catering
                      "
                    >
                      <span class="btn-mark">
                        <label
                          class="blue-tick"
                          *ngIf="
                            !helper.common_data.cart_data.ipickup_delivery &&
                            helper.common_data.cart_data.is_catering
                          "
                        >
                          <svg
                            width="10"
                            height="9"
                            viewBox="0 0 10 9"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1.37549 4.08445L4.06834 7.67491L8.55642 1.3916"
                              stroke-width="1.61571"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </label>
                      </span>
                      <svg
                        width="18"
                        height="22"
                        viewBox="0 0 38 31"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1 19.0554H37M34.9692 19.0554C34.9692 10.2363 27.82 3.08618 19 3.08618C10.18 3.08618 3.03077 10.2363 3.03077 19.0554"
                          stroke="#DDD1BA"
                          stroke-width="1.84615"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M12.3494 6.96492C10.6995 8.04127 9.33587 9.50244 8.3759 11.2227C7.41593 12.9429 6.88838 14.8707 6.83866 16.84M19.0002 3.08615V1M19.8679 25.2585C24.666 25.2003 25.2808 25 34.1525 22.7477C34.711 22.6065 35.1254 22.8926 35.2473 23.2175C35.3719 23.5498 35.3211 24.1388 34.5633 24.3354C33.0679 24.7231 23.7448 29.0246 21.6217 29.0246C19.4987 29.0246 13.314 28.5631 10.9879 28.5631C8.66174 28.5631 5.94789 30.04 5.94789 30.04C4.08328 28.3046 2.90174 25.4246 2.58789 22.3046H25.6279C26.5787 22.3046 26.8833 23.6338 26.071 24.0031C24.8664 24.5505 22.8217 25.2585 19.8679 25.2585Z"
                          stroke="#DDD1BA"
                          stroke-width="1.84615"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      {{ helper.button.catering | translate }}
                    </button>
                  </div>
                </div>
                <div class="d-l-block">
                  <div class="block-title">
                    <h3>{{ helper.title.quand | translate }}</h3>
                  </div>
                  <div class="deli-type-btn">
                    <button
                      class="primary-btn"
                      (click)="
                        delivery_setting_service.change_schedule(
                          false,
                          current_store
                        )
                      "
                      [hidden]="
                        helper.website_data.detail.is_close_asap &&
                        ((!helper.website_data.detail.is_pickup_possible &&
                          helper.common_data.cart_data.ipickup_delivery) ||
                          (!helper.website_data.detail.is_delivery_possible &&
                            !helper.common_data.cart_data.ipickup_delivery) ||
                          current_store.is_only_schedule_order)
                      "
                      [class.active]="
                        !helper.common_data.cart_data.is_schedule_order
                      "
                    >
                      <span class="btn-mark">
                        <label
                          class="blue-tick"
                          *ngIf="
                            !helper.common_data.cart_data.is_schedule_order
                          "
                        >
                          <svg
                            width="10"
                            height="9"
                            viewBox="0 0 10 9"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1.37549 4.08445L4.06834 7.67491L8.55642 1.3916"
                              stroke-width="1.61571"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </label>
                      </span>
                      <svg
                        width="13"
                        height="19"
                        viewBox="0 0 13 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M3.12576 18.8213C2.9878 18.763 2.87317 18.6605 2.79993 18.5299C2.72669 18.3993 2.69902 18.248 2.72129 18.1L3.94816 10.1118H0.692235C0.589013 10.1146 0.486532 10.0936 0.3927 10.0505C0.298868 10.0074 0.216192 9.94333 0.151053 9.8632C0.0859135 9.78308 0.0400511 9.68907 0.0170044 9.58841C-0.00604226 9.48776 -0.00565705 9.38315 0.0181301 9.28267L2.04045 0.519302C2.07603 0.368484 2.16249 0.234532 2.28527 0.139992C2.40805 0.0454527 2.55965 -0.00390035 2.71455 0.000240933H9.4556C9.55631 -0.000101493 9.65582 0.0221249 9.74681 0.0652869C9.8378 0.108449 9.91796 0.17145 9.98141 0.24966C10.0457 0.328754 10.0913 0.421412 10.1147 0.520661C10.138 0.61991 10.1386 0.723164 10.1162 0.822649L8.95003 6.06719H12.152C12.2784 6.06694 12.4022 6.10219 12.5095 6.16894C12.6168 6.23569 12.7031 6.33123 12.7587 6.44469C12.807 6.55358 12.8256 6.67333 12.8126 6.79174C12.7996 6.91016 12.7554 7.023 12.6846 7.11879L3.9212 18.5786C3.86197 18.6664 3.78289 18.739 3.69037 18.7905C3.59785 18.8421 3.49448 18.8711 3.38866 18.8752C3.29846 18.8735 3.20934 18.8552 3.12576 18.8213Z"
                        />
                      </svg>
                      {{ helper.button.des_que_possible | translate }}
                    </button>
                    <div
                      class="d-alert-msg"
                      *ngIf="
                        helper.website_data.detail.is_close_asap &&
                        !current_store.is_only_schedule_order &&
                        ((!helper.website_data.detail.is_pickup_possible &&
                          helper.common_data.cart_data.ipickup_delivery) ||
                          (!helper.website_data.detail.is_delivery_possible &&
                            !helper.common_data.cart_data.ipickup_delivery))
                      "
                    >
                      <p class="black">
                        {{ helper.text.d_alert_msg2 | translate }}
                      </p>
                    </div>
                    <button
                      class="primary-btn"
                      (click)="
                        delivery_setting_service.change_schedule(
                          true,
                          current_store
                        )
                      "
                      [class.active]="
                        helper.common_data.cart_data.is_schedule_order
                      "
                    >
                      <span class="btn-mark">
                        <label
                          class="blue-tick"
                          *ngIf="helper.common_data.cart_data.is_schedule_order"
                        >
                          <svg
                            width="10"
                            height="9"
                            viewBox="0 0 10 9"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1.37549 4.08445L4.06834 7.67491L8.55642 1.3916"
                              stroke-width="1.61571"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </label>
                      </span>
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7 11H9V13H7V11ZM7 15H9V17H7V15ZM11 11H13V13H11V11ZM11 15H13V17H11V15ZM15 11H17V13H15V11ZM15 15H17V17H15V15Z"
                        />
                        <path
                          d="M5 22H19C20.103 22 21 21.103 21 20V6C21 4.897 20.103 4 19 4H17V2H15V4H9V2H7V4H5C3.897 4 3 4.897 3 6V20C3 21.103 3.897 22 5 22ZM19 8L19.001 20H5V8H19Z"
                        />
                      </svg>
                      {{ helper.button.plus_tard | translate }}
                    </button>
                    <div
                      class="d-alert-msg"
                      *ngIf="current_store.is_only_schedule_order"
                    >
                      <p class="gray">
                        Uniquement en précommande min.
                        {{ current_store.only_schedule_order_after_hour }}h à
                        l’avance.
                      </p>
                    </div>
                  </div>
                  <div
                    class="shop-d-h"
                    *ngIf="helper.common_data.cart_data.is_schedule_order"
                  >
                    <div class="date-dropdown">
                      <label for="">{{ helper.label.date | translate }}</label>
                      <div class="d-wrp">
                        <button
                          class="primary-btn d-dropdown"
                          (click)="
                            delivery_setting_service.is_show_date =
                              !delivery_setting_service.is_show_date;
                            delivery_setting_service.is_show_time = false
                          "
                          [class.active]="delivery_setting_service.is_show_date"
                        >
                          {{ delivery_setting_service.clicked_date }}
                          <svg
                            width="14"
                            height="9"
                            viewBox="0 0 14 9"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1 1L7 7L13 1"
                              stroke="black"
                              stroke-width="2.25"
                            />
                          </svg>
                        </button>
                        <ul
                          class="dropdown-menu-list v-scroll-hide"
                          [hidden]="!delivery_setting_service.is_show_date"
                        >
                          <li
                            *ngFor="
                              let date of delivery_setting_service.date_array
                            "
                            (click)="
                              delivery_setting_service.set_date(
                                date,
                                current_store
                              )
                            "
                          >
                            {{ date.date_format }}
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="date-dropdown hour-dropdown">
                      <label for="">{{ helper.label.heure | translate }}</label>
                      <div class="d-wrp">
                        <button
                          class="primary-btn d-dropdown"
                          (click)="
                            delivery_setting_service.select_time(current_store)
                          "
                          [class.active]="delivery_setting_service.is_show_time"
                        >
                          {{ delivery_setting_service.schedule_time }}
                          <svg
                            width="14"
                            height="9"
                            viewBox="0 0 14 9"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1 1L7 7L13 1"
                              stroke="black"
                              stroke-width="2.25"
                            />
                          </svg>
                        </button>
                        <ul
                          class="dropdown-menu-list v-scroll-hide"
                          [hidden]="!delivery_setting_service.is_show_time"
                        >
                          <li
                            *ngFor="
                              let time of delivery_setting_service.time_array
                            "
                            (click)="
                              delivery_setting_service.set_time(
                                time,
                                current_store
                              )
                            "
                          >
                            {{ time.time_format }}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="d-l-block"
                  *ngIf="!helper.common_data.cart_data.ipickup_delivery"
                >
                  <div class="block-title">
                    <h3>{{ helper.title.a_quelle_adresse | translate }}</h3>
                  </div>
                  <div class="input-dropdown">
                    <form
                      action=""
                      class="add-control shop-add-control"
                      [class.error]="!delivery_setting_service.is_address_valid"
                      [class.active]="delivery_setting_service.is_show_address"
                    >
                      <input
                        type="text"
                        (keydown)="
                          delivery_setting_service.is_show_address = true
                        "
                        [(ngModel)]="helper.common_data.cart_data.address"
                        #address="ngModel"
                        id="address"
                        name="address"
                        autocomplete="off"
                        class="form-control"
                        [class.active]="
                          delivery_setting_service.is_show_address
                        "
                        [class.error]="
                          !delivery_setting_service.is_address_valid
                        "
                        placeholder="{{
                          helper.placeholder.entrez_votre_adresse | translate
                        }}"
                      />
                      <span
                        *ngIf="
                          delivery_setting_service.favourite_addresses.length >
                          0
                        "
                        class="form-control-svg"
                        (click)="delivery_setting_service.set_show_address()"
                      >
                        <svg
                          width="21"
                          height="13"
                          viewBox="0 0 21 13"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M3 2.62207L10.5 10.699L18 2.62207"
                            stroke-width="3"
                            stroke-linecap="square"
                          />
                        </svg>
                      </span>
                      <span class="form-control-svg location">
                        <svg
                          width="13"
                          height="15"
                          viewBox="0 0 13 15"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M6.50016 0.416687C3.52516 0.416687 0.833496 2.69752 0.833496 6.22502C0.833496 8.47752 2.56891 11.1267 6.03266 14.1796C6.30183 14.4134 6.70558 14.4134 6.97475 14.1796C10.4314 11.1267 12.1668 8.47752 12.1668 6.22502C12.1668 2.69752 9.47516 0.416687 6.50016 0.416687ZM6.50016 7.50002C5.721 7.50002 5.0835 6.86252 5.0835 6.08335C5.0835 5.30419 5.721 4.66669 6.50016 4.66669C7.27933 4.66669 7.91683 5.30419 7.91683 6.08335C7.91683 6.86252 7.27933 7.50002 6.50016 7.50002Z"
                            fill="black"
                          />
                        </svg>
                      </span>
                    </form>
                    <div
                      class="add-con-dropdown-list v-scroll-hide"
                      [class.active]="delivery_setting_service.is_show_address"
                      *ngIf="delivery_setting_service.is_show_address"
                    >
                      <h3>
                        {{ helper.title.vos_adresse_enregistrees | translate }}
                      </h3>
                      <div class="address-form-list-main">
                        <form action="">
                          <ng-container
                            *ngFor="
                              let address of delivery_setting_service.favourite_addresses
                                | searchpipe
                                  : helper.common_data.cart_data.address
                                  : ['address']
                            "
                          >
                            <div
                              class="address-form-list"
                              *ngIf="address.address && address.latitude"
                            >
                              <input
                                (click)="
                                  delivery_setting_service.select_address(
                                    address,
                                    current_store
                                  )
                                "
                                type="text"
                                class="form-control"
                                placeholder="{{ address.address }}"
                                value="{{ address.address }}"
                                readonly
                              />
                            </div>
                          </ng-container>
                        </form>
                      </div>
                    </div>
                  </div>

                  <div
                    class="d-alert-msg m-t-15"
                    *ngIf="!delivery_setting_service.is_address_valid"
                  >
                    <p>{{ helper.text.d_alert_msg3 | translate }}</p>
                  </div>
                  <div
                    class="d-alert-msg m-t-15"
                    *ngIf="!helper.common_data.cart_data.address"
                  >
                    <p>{{ helper.text.d_alert_msg4 | translate }}</p>
                  </div>
                  <div class="e-s-p-link">
                    <button
                      (click)="
                        is_show_header_popup = false;
                        ScopeOfDelivery.openModal1()
                      "
                      class="primary-btn link-btn"
                    >
                      {{ helper.button.delivery_area_link | translate }}
                    </button>
                  </div>

                  <div
                    class="error-msg"
                    *ngIf="
                      delivery_setting_service.schedule_time_error &&
                      helper.common_data.cart_data.is_schedule_order
                    "
                  >
                    {{ helper.title.schedule_time_error | translate }}
                  </div>
                  <div class="error-msg" *ngIf="current_store.close">
                    <p *ngIf="current_store.nextopentime">
                      {{ helper.title.reopen_at | translate }}
                      {{ current_store.nextopentime }}
                      <span *ngIf="current_store.next_order_time">
                        {{ helper.title.order_at | translate }}
                        {{ current_store.next_order_time }}
                      </span>
                    </p>
                    <p *ngIf="!current_store.nextopentime">
                      {{ helper.title.reopen_at | translate }}
                      {{ helper.title.store_closed_today }}
                    </p>
                  </div>
                </div>

                <!-- <div class="d-l-block d-l-b-mob">
                                    <button (click)="close_header_popup()" class="primary-btn valider-btn-mob">{{helper.button.valider | translate}}</button>
                                </div> -->
              </div>
              <div class="valider-btn ml-auto">
                <button (click)="close_header_popup()" class="primary-btn">
                  {{ helper.button.valider | translate }}
                </button>
              </div>
            </div>
          </div>
          <div class="menu-plus ml-auto" [class.active]="is_language_dropdown">
            <button
              class="primary-btn"
              (click)="is_language_dropdown = !is_language_dropdown"
            >
              {{ helper.website_data.selected_language | translate }}
              <svg
                width="13"
                height="9"
                viewBox="0 0 13 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M1 1L6.5 7L12 1" stroke-width="2" />
              </svg>
            </button>
            <ul class="v-scroll-hide" *ngIf="is_language_dropdown">
              <li
                *ngFor="
                  let product of helper.website_data.language_list;
                  let index = index
                "
                [class.active]="
                  product.code == helper.website_data.selected_language
                "
                (click)="
                  helper.select_language(product.code, index);
                  is_language_dropdown = false
                "
              >
                <a>{{ product.code }}</a>
              </li>
            </ul>
          </div>
          <div class="login-btn" *ngIf="!user_id">
            <button
              class="primary-btn svg-left"
              (click)="
                is_register_button = true;
                is_second_text = true;
                login_header_text = helper.text.pay_text1;
                AccountPopup.openModal()
              "
            >
              <svg
                width="23"
                height="23"
                viewBox="0 0 23 23"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.9705 0.997107C9.89108 1.00225 7.85568 1.59675 6.10036 2.71167C4.34504 3.8266 2.94169 5.41627 2.05305 7.29635C1.1644 9.17644 0.82687 11.2699 1.07958 13.334C1.3323 15.3982 2.16491 17.3484 3.48087 18.9585C3.89135 18.365 4.35257 17.7442 4.84461 17.1308C4.81486 17.1389 4.78458 17.1449 4.754 17.1489C4.61223 17.168 4.46799 17.1447 4.33943 17.0819C4.21088 17.0192 4.10375 16.9198 4.03155 16.7963C3.95935 16.6728 3.92529 16.5308 3.93367 16.3879C3.94205 16.2451 3.99248 16.108 4.07863 15.9938C4.16478 15.8796 4.28279 15.7935 4.4178 15.7462C4.55281 15.6989 4.69878 15.6926 4.83735 15.7282C4.97591 15.7637 5.10087 15.8394 5.19649 15.9458C5.29211 16.0522 5.35412 16.1845 5.3747 16.3261C5.38148 16.3771 5.3833 16.4287 5.38014 16.4801C6.68771 14.9396 8.2354 13.6084 9.533 12.8318C9.54115 12.8318 10.711 12.2682 10.8478 12.2419C10.9176 12.2274 9.92717 12.2655 9.55112 12.2745C9.00172 12.2867 8.45206 12.2686 7.90466 12.2202C6.69042 12.0688 3.52798 11.0612 4.64798 10.5501C5.82596 10.0064 8.91863 9.96739 9.72238 9.9384C10.1166 9.9248 11.2211 10.0653 11.1604 10.0172C10.7844 9.71548 8.1176 9.82422 6.37418 8.49757C5.91386 8.14778 6.0226 7.56692 6.72486 7.55695C9.2385 7.51889 11.0743 7.48989 13.3261 8.45407C13.9396 8.76308 14.0392 8.8256 14.3999 8.7812C16.281 8.54831 17.797 9.27326 18.6733 10.7123C19.0239 11.2877 18.8463 11.4789 18.4567 12.1069C17.9284 12.9569 15.9548 13.1943 15.5144 13.1254C15.5081 13.2145 15.5198 13.3038 15.5489 13.3882C16.2738 13.323 17.7925 13.3819 18.4748 13.5477C18.7467 13.6148 19.1345 13.7616 19.1091 14.2808C19.0883 14.7656 18.5464 15.0121 18.3461 15.0058C14.5712 14.8889 9.66167 17.2712 5.85677 19.7741C5.60124 19.9417 5.26597 20.1601 4.89445 20.3993C6.24714 21.5435 7.85611 22.344 9.58454 22.7328C11.313 23.1216 13.1097 23.0872 14.822 22.6325C16.5343 22.1779 18.1115 21.3164 19.4194 20.1214C20.7274 18.9264 21.7274 17.4332 22.3344 15.7687C22.9414 14.1043 23.1375 12.3179 22.906 10.5614C22.6745 8.80485 22.0223 7.13024 21.0047 5.67992C19.9872 4.22961 18.6344 3.0465 17.0615 2.2312C15.4886 1.41591 13.7421 0.99254 11.9705 0.997107Z"
                  fill="white"
                />
              </svg>
              {{ helper.button.se_connecter | translate }}
            </button>
          </div>
          <div class="login-btn after-login" *ngIf="user_id">
            <button class="primary-btn svg-left only-svg">
              <svg
                width="20"
                height="19"
                viewBox="0 0 20 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.76807 0.351929C8.43606 0.351929 7.39542 0.842182 6.64617 1.82269C5.89691 2.80319 5.52229 4.05658 5.52229 5.58284C5.51304 7.4791 6.12354 8.98224 7.3538 10.0922C7.51105 10.2402 7.56655 10.4299 7.5203 10.6611L7.20117 11.3271C7.09942 11.5491 6.94911 11.7226 6.75023 11.8474C6.55136 11.9723 6.13279 12.1504 5.49454 12.3816C5.46679 12.3909 4.88172 12.5805 3.73934 12.9505C2.59695 13.3205 1.98876 13.524 1.91476 13.561C1.13776 13.8848 0.629004 14.2224 0.388503 14.5739C0.129501 15.1567 0 16.632 0 19.0001H19.5361C19.5361 16.632 19.4066 15.1567 19.1476 14.5739C18.9071 14.2224 18.3984 13.8848 17.6214 13.561C17.5474 13.524 16.9392 13.3205 15.7968 12.9505C14.6544 12.5805 14.0693 12.3909 14.0416 12.3816C13.4033 12.1504 12.9848 11.9723 12.7859 11.8474C12.587 11.7226 12.4367 11.5491 12.335 11.3271L12.0158 10.6611C11.9696 10.4299 12.0251 10.2402 12.1823 10.0922C13.4126 8.98224 14.0231 7.4791 14.0138 5.58284C14.0138 4.05658 13.6392 2.80319 12.89 1.82269C12.1407 0.842182 11.1001 0.351929 9.76807 0.351929Z"
                />
              </svg>
            </button>
            <app-profile-menu></app-profile-menu>
          </div>
        </div>
      </div>
      <div
        class="estimated-delivery"
        id="estimated-delivery"
        *ngIf="!current_store.close"
      >
        <p>
          <span *ngIf="!helper.common_data.cart_data.ipickup_delivery">{{
            helper.text.order_deli_time | translate
          }}</span>
          <span *ngIf="helper.common_data.cart_data.ipickup_delivery">{{
            helper.text.order_deli_time1 | translate
          }}</span>
          <span *ngIf="!helper.common_data.cart_data.is_schedule_order">
            {{ delivery_setting_service.delivered_time }}</span
          >
          <span *ngIf="helper.common_data.cart_data.is_schedule_order">
            {{ delivery_setting_service.clicked_date }},
            {{ delivery_setting_service.schedule_time }}</span
          >
        </p>
      </div>
      <div
        class="estimated-delivery"
        id="estimated-delivery"
        *ngIf="current_store.close"
      >
        <p *ngIf="current_store.nextopentime">
          {{ helper.title.reopen_at | translate }}
          {{ current_store.nextopentime }}
          <span *ngIf="current_store.next_order_time">
            {{ helper.title.order_at | translate }}
            {{ current_store.next_order_time }}
          </span>
        </p>
        <p *ngIf="!current_store.nextopentime">
          {{ helper.title.reopen_at | translate }}
          {{ helper.title.store_closed_today }}
        </p>
      </div>

      <div
        class="menu-content"
        id="menu-content"
        [class.menu-content-sticky]="is_header_sticky"
      >
        <div class="menu-content-wrp">
          <div class="menu-hori-main d-flex align-items-center">
            <ul class="nav nav-tabs">
              <li
                class="nav-item"
                *ngFor="let product of filtered_product_list"
                [class.active]="product._id._id == selected_product_id"
                (click)="select_product(product._id._id)"
              >
                <a
                  class="nav-link"
                  [class.active]="product._id._id == selected_product_id"
                >
                  <span>{{ product._id.name }}</span>
                </a>
              </li>
            </ul>
            <div class="menu-list-right d-flex align-items-center ml-auto">
              <div class="menu-plus" [class.active]="is_open_product_dropdown">
                <button
                  class="primary-btn"
                  (click)="is_open_product_dropdown = !is_open_product_dropdown"
                >
                  {{ helper.button.voir_plus | translate }}
                  <svg
                    width="13"
                    height="9"
                    viewBox="0 0 13 9"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M1 1L6.5 7L12 1" stroke-width="2" />
                  </svg>
                </button>
                <ul class="v-scroll-hide" *ngIf="is_open_product_dropdown">
                  <li
                    *ngFor="let product of filtered_product_list"
                    [class.active]="product._id._id == selected_product_id"
                    (click)="select_product(product._id._id)"
                  >
                    <a>{{ product._id.name }}</a>
                  </li>
                </ul>
              </div>
              <div class="menu-cart-btn">
                <button
                  class="primary-btn btn-desktop"
                  (click)="is_show_cart = !is_show_cart"
                >
                  <label>
                    {{ helper.button.panier | translate }}
                    <svg
                      width="16"
                      height="14"
                      viewBox="0 0 16 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_1842_9206)">
                        <path
                          d="M14.4407 8.23916L15.7333 2.55168C15.8267 2.14103 15.5145 1.74999 15.0934 1.74999H4.35333L4.1027 0.524725C4.04024 0.219323 3.77151 0 3.45976 0H0.656247C0.293807 0 0 0.293807 0 0.656247V1.09375C0 1.45619 0.293807 1.74999 0.656247 1.74999H2.5671L4.48794 11.1408C4.0284 11.405 3.71874 11.9006 3.71874 12.4687C3.71874 13.3144 4.4043 13.9999 5.24998 13.9999C6.09566 13.9999 6.78122 13.3144 6.78122 12.4687C6.78122 12.0401 6.60494 11.6529 6.32119 11.375H12.0537C11.77 11.6529 11.5937 12.0401 11.5937 12.4687C11.5937 13.3144 12.2793 13.9999 13.125 13.9999C13.9706 13.9999 14.6562 13.3144 14.6562 12.4687C14.6562 11.8624 14.3038 11.3385 13.7927 11.0904L13.9436 10.4267C14.0369 10.016 13.7248 9.62496 13.3036 9.62496H5.96411L5.78515 8.74997H13.8008C14.1072 8.74997 14.3728 8.53794 14.4407 8.23916Z"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_1842_9206">
                          <rect width="15.7499" height="13.9999" />
                        </clipPath>
                      </defs>
                    </svg>
                    <span
                      class="count-pill"
                      *ngIf="helper.common_data._user_cart.cart_data.total_item"
                      >{{
                        helper.common_data._user_cart.cart_data.total_item
                      }}</span
                    >
                  </label>
                  <span
                    >{{ delivery_currency }}
                    {{
                      helper.common_data._user_cart.cart_data.total_cart_amount.toFixed(
                        2
                      )
                    }}</span
                  >
                </button>
                <!-- <button class="primary-btn btn-mob" *ngIf="!is_show_cart" (click)="show_mobile_cart()">
                                    <label>
                                        {{helper.button.voir_votre_panier | translate}} <span>{{delivery_currency}} {{helper.common_data._user_cart.cart_data.total_cart_amount.toFixed(2)}}</span>
                                    </label>
                                    <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_1842_9206)">
                                        <path d="M14.4407 8.23916L15.7333 2.55168C15.8267 2.14103 15.5145 1.74999 15.0934 1.74999H4.35333L4.1027 0.524725C4.04024 0.219323 3.77151 0 3.45976 0H0.656247C0.293807 0 0 0.293807 0 0.656247V1.09375C0 1.45619 0.293807 1.74999 0.656247 1.74999H2.5671L4.48794 11.1408C4.0284 11.405 3.71874 11.9006 3.71874 12.4687C3.71874 13.3144 4.4043 13.9999 5.24998 13.9999C6.09566 13.9999 6.78122 13.3144 6.78122 12.4687C6.78122 12.0401 6.60494 11.6529 6.32119 11.375H12.0537C11.77 11.6529 11.5937 12.0401 11.5937 12.4687C11.5937 13.3144 12.2793 13.9999 13.125 13.9999C13.9706 13.9999 14.6562 13.3144 14.6562 12.4687C14.6562 11.8624 14.3038 11.3385 13.7927 11.0904L13.9436 10.4267C14.0369 10.016 13.7248 9.62496 13.3036 9.62496H5.96411L5.78515 8.74997H13.8008C14.1072 8.74997 14.3728 8.53794 14.4407 8.23916Z"/>
                                        </g>
                                        <defs>
                                        <clipPath id="clip0_1842_9206">
                                        <rect width="15.7499" height="13.9999"/>
                                        </clipPath>
                                        </defs>
                                    </svg>
                                </button>
                                <button class="primary-btn btn-mob" *ngIf="is_show_cart" (click)="go_to_checkout()">
                                    <label class="d-flex align-items-center">
                                        {{helper.button.cart_d_btn | translate}} <span class="ml-auto">{{delivery_currency}} {{helper.common_data._user_cart.cart_data.total_cart_amount.toFixed(2)}}</span>
                                    </label>
                                </button> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="product-item-list-main"
      [class.product-item-list-main-offer]="
        offer_service.cart_offer_error2 || offer_service.cart_offer_message
      "
      [class.product-item-list-main-cart-open]="is_show_cart"
      [ngStyle]="get_style()"
    >
      <div class="re-order-btn">
        <button
          *ngIf="!user_id"
          class="primary-btn svg-left border-btn"
          (click)="
            is_register_button = false;
            is_second_text = false;
            login_header_text = helper.text.pay_text3;
            AccountPopup.openModal()
          "
        >
          <svg
            width="26"
            height="25"
            viewBox="0 0 26 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_1960_3600)">
              <path
                d="M19.0578 19.575C17.3575 21.2117 15.1195 22.231 12.7252 22.4591C10.331 22.6872 7.92851 22.11 5.92718 20.8259C3.92585 19.5418 2.44947 17.6302 1.74957 15.4168C1.04967 13.2034 1.16955 10.8251 2.08879 8.68719C3.00803 6.54925 4.66976 4.7839 6.79086 3.69192C8.91196 2.59993 11.3612 2.24888 13.7213 2.69856C16.0814 3.14824 18.2064 4.37083 19.7341 6.15804C21.2619 7.94525 22.0979 10.1865 22.0998 12.5H19.4998C19.5014 10.7647 18.8772 9.08263 17.7335 7.74033C16.5898 6.39803 14.9974 5.47859 13.2278 5.13867C11.4581 4.79875 9.62054 5.05939 8.02831 5.87618C6.43607 6.69297 5.18766 8.01537 4.49579 9.61803C3.80393 11.2207 3.71142 13.0044 4.23405 14.6653C4.75667 16.3262 5.86208 17.7615 7.3619 18.7265C8.86173 19.6916 10.6632 20.1267 12.4593 19.9577C14.2553 19.7888 15.9349 19.0262 17.2118 17.8L19.0578 19.575ZM15.5998 12.5H25.9998L20.7998 17.5L15.5998 12.5Z"
              />
            </g>
            <defs>
              <clipPath id="clip0_1960_3600">
                <rect width="26" height="25" fill="white" />
              </clipPath>
            </defs>
          </svg>
          {{ helper.button.re_order_btn1 | translate }}
        </button>
        <button
          *ngIf="user_id"
          class="primary-btn svg-left border-btn"
          (click)="get_order_history(ReOrder)"
        >
          <svg
            width="26"
            height="25"
            viewBox="0 0 26 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_1960_3600)">
              <path
                d="M19.0578 19.575C17.3575 21.2117 15.1195 22.231 12.7252 22.4591C10.331 22.6872 7.92851 22.11 5.92718 20.8259C3.92585 19.5418 2.44947 17.6302 1.74957 15.4168C1.04967 13.2034 1.16955 10.8251 2.08879 8.68719C3.00803 6.54925 4.66976 4.7839 6.79086 3.69192C8.91196 2.59993 11.3612 2.24888 13.7213 2.69856C16.0814 3.14824 18.2064 4.37083 19.7341 6.15804C21.2619 7.94525 22.0979 10.1865 22.0998 12.5H19.4998C19.5014 10.7647 18.8772 9.08263 17.7335 7.74033C16.5898 6.39803 14.9974 5.47859 13.2278 5.13867C11.4581 4.79875 9.62054 5.05939 8.02831 5.87618C6.43607 6.69297 5.18766 8.01537 4.49579 9.61803C3.80393 11.2207 3.71142 13.0044 4.23405 14.6653C4.75667 16.3262 5.86208 17.7615 7.3619 18.7265C8.86173 19.6916 10.6632 20.1267 12.4593 19.9577C14.2553 19.7888 15.9349 19.0262 17.2118 17.8L19.0578 19.575ZM15.5998 12.5H25.9998L20.7998 17.5L15.5998 12.5Z"
              />
            </g>
            <defs>
              <clipPath id="clip0_1960_3600">
                <rect width="26" height="25" fill="white" />
              </clipPath>
            </defs>
          </svg>
          {{ helper.button.re_order_btn | translate }}
        </button>
      </div>
      <div
        class="product-item-list"
        [class.unavailable]="!product._id.is_available"
        *ngFor="let product of filtered_product_list"
        id="product{{ product._id._id }}"
      >
        <div class="p-t-with-btn d-flex align-items-center">
          <h2>{{ product._id.name }}</h2>
          <div
            class="unavailable-btn d-flex align-items-center"
            *ngIf="!product._id.is_available"
          >
            <button class="primary-btn">
              {{ helper.button.indisponible | translate }}
              <span>{{ helper.button.actuellement | translate }}</span>
            </button>
          </div>
          <div
            class="available-from d-flex align-items-center"
            *ngIf="product._id.available_text"
          >
            <!-- <label>{{helper.label.disponible_des | translate}}</label> -->
            <span>{{ product._id.available_text }}</span>
          </div>
        </div>

        <div class="p-item-list-wrp">
          <div class="row">
            <div
              class="col-lg-4 col-sm-6 d-flex m-b-30"
              *ngFor="let item of product.items"
            >
              <div
                class="product-list-block d-flex align-items-center"
                (click)="
                  open_item_modal(
                    ProductItem,
                    item,
                    product._id.name,
                    product._id.unique_id
                  )
                "
              >
                <div class="product-content">
                  <h3>{{ item.name }}</h3>
                  <p>{{ item.details }}</p>
                  <div class="d-flex">
                    <span
                      class="p-price pro-strike-price"
                      *ngIf="item.offer_price > 0"
                      >{{ delivery_currency }}
                      {{ item.total_item_price.toFixed(2) }}</span
                    >
                    <span class="p-price"
                      >{{ delivery_currency }}
                      {{
                        (item.offer_price > 0
                          ? item.offer_price
                          : item.total_item_price
                        ).toFixed(2)
                      }}</span
                    >
                  </div>
                </div>
                <div
                  class="product-img ml-auto"
                  [class.only-tag]="
                    !item.image_url[0] &&
                    (item.is_most_popular ||
                      (item.offer_tags && item.offer_tags.length > 0))
                  "
                >
                  <img
                    *ngIf="item.image_url[0]"
                    [defaultImage]="helper.website_data.detail.site_logo"
                    [offset]="500"
                    [errorImage]="helper.website_data.detail.site_logo"
                    [lazyLoad]="helper.get_image(item.image_url[0], 300, 300)"
                    alt=""
                  />
                  <div class="pro-tag-list">
                    <div class="popular-tag" *ngIf="item.is_most_popular">
                      <span>
                        {{ helper.label.populaire | translate }}
                        <svg
                          width="13"
                          height="16"
                          viewBox="0 0 13 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            x="2"
                            y="3"
                            width="9"
                            height="7"
                            fill="#F9D101"
                          />
                          <path
                            d="M6.5 0C4.77672 0.00196598 3.1246 0.664841 1.90606 1.84321C0.687511 3.02159 0.00203992 4.61924 6.91533e-06 6.28571C-0.00205706 7.64756 0.457949 8.97245 1.30946 10.0571C1.30946 10.0571 1.48673 10.2829 1.51569 10.3154L5.71562 15.1054C6.13116 15.5793 6.86884 15.5793 7.28437 15.1054L11.4867 10.3126C11.5127 10.2823 11.6905 10.0571 11.6905 10.0571L11.6911 10.0554C12.5422 8.97121 13.002 7.64693 13 6.28571C12.998 4.61924 12.3125 3.02159 11.0939 1.84321C9.8754 0.664841 8.22328 0.00196598 6.5 0ZM8.62727 9.14286L6.5 7.83371L4.37273 9.14286L4.72727 6.81486L2.95455 5.24171L5.43637 4.952L6.5 2.85714L7.62982 4.95257L10.0455 5.24171L8.27273 6.81486L8.62727 9.14286Z"
                            fill="white"
                          />
                        </svg>
                      </span>
                    </div>
                    <ng-container *ngIf="item.offer_tags">
                      <div
                        class="popular-tag percentage-tag"
                        *ngFor="let offer of item.offer_tags"
                      >
                        <span>
                          {{ offer.offer_tag | translate }}
                          <svg
                            width="20"
                            height="19"
                            viewBox="0 0 20 19"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clip-path="url(#clip0_1960_3372)">
                              <path
                                d="M18.762 0.377949C18.7079 0.243093 18.6038 0.134305 18.4715 0.0742156C18.3392 0.0141265 18.1888 0.00736299 18.0516 0.0553322C17.9144 0.103301 17.801 0.20231 17.735 0.33176C17.669 0.461211 17.6554 0.611137 17.6971 0.750349C18.5641 3.24235 16.8431 5.10341 15.5308 6.10021L15.0007 5.34048C14.8224 5.08568 14.4239 4.87382 14.114 4.87008L11.1385 4.88315C10.7751 4.89413 10.4213 5.00312 10.1147 5.19862L1.34695 11.3465C1.14301 11.49 1.00425 11.7085 0.961039 11.9541C0.917831 12.1997 0.973701 12.4524 1.11642 12.6569L5.10081 18.3577C5.39948 18.7823 5.87642 18.731 6.30202 18.4342L15.0697 12.2854C15.3217 12.1071 15.6129 11.7226 15.7156 11.4286L16.6471 8.49328C16.7497 8.20021 16.6872 7.75315 16.5089 7.49835L16.186 7.03541C17.9481 5.68488 19.7775 3.29835 18.762 0.377949ZM14.6824 9.11208C14.5209 9.22515 14.3387 9.30528 14.1462 9.34789C13.9537 9.39051 13.7547 9.39478 13.5605 9.36045C13.3664 9.32613 13.1809 9.25389 13.0146 9.14785C12.8484 9.04182 12.7047 8.90407 12.5917 8.74248C12.363 8.41549 12.2734 8.01111 12.3425 7.61809C12.4116 7.22508 12.6338 6.87554 12.9604 6.64621C13.2164 6.46684 13.5221 6.37195 13.8347 6.37479C14.1473 6.37764 14.4512 6.47808 14.7039 6.66208C14.45 6.81515 14.2755 6.90475 14.2428 6.91875C14.1271 6.97391 14.0336 7.06674 13.9776 7.18202C13.9215 7.2973 13.9063 7.42819 13.9344 7.55325C13.9625 7.6783 14.0322 7.79011 14.1322 7.87035C14.2321 7.95059 14.3564 7.9945 14.4845 7.99488C14.5648 7.99488 14.6469 7.97621 14.7244 7.93981C14.9055 7.85395 15.0996 7.75221 15.3021 7.63181C15.3487 7.91187 15.3153 8.19939 15.2056 8.46128C15.096 8.72316 14.9146 8.94875 14.6824 9.11208Z"
                                fill="#AD3E00"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_1960_3372">
                                <rect
                                  width="18.6667"
                                  height="18.6667"
                                  fill="white"
                                  transform="translate(0.666504)"
                                />
                              </clipPath>
                            </defs>
                          </svg>
                        </span>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
              <!-- <div class="indisponible-tag" *ngIf="!item.is_available">
                                <span>{{helper.button.indisponible_actuellement | translate}}</span>
                            </div> -->
            </div>
          </div>
        </div>
      </div>
      <div
        class="cart-dropdown v-scroll-hide fadein"
        [ngStyle]="{ height: 'calc(100vh - ' + header_height + 'px)' }"
      >
        <div
          class="cart-dropdown-wrp"
          [class.cart-dropdown-wrp-offer]="
            offer_service.cart_offer_error2 || offer_service.cart_offer_message
          "
        >
          <div class="close-shopping-cart">
            <button
              class="primary-btn svg-left border-btn"
              (click)="close_cart()"
            >
              <svg
                width="25"
                height="25"
                viewBox="0 0 25 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.5 0C10.0277 0 7.61099 0.733112 5.55538 2.10663C3.49976 3.48015 1.89761 5.43238 0.951511 7.71645C0.00541605 10.0005 -0.242126 12.5139 0.24019 14.9386C0.722505 17.3634 1.91301 19.5907 3.66117 21.3388C5.40933 23.087 7.63661 24.2775 10.0614 24.7598C12.4861 25.2421 14.9995 24.9946 17.2835 24.0485C19.5676 23.1024 21.5199 21.5002 22.8934 19.4446C24.2669 17.389 25 14.9723 25 12.5C25 10.8585 24.6767 9.23302 24.0485 7.71645C23.4203 6.19988 22.4996 4.8219 21.3388 3.66116C20.1781 2.50043 18.8001 1.57969 17.2835 0.951506C15.767 0.323322 14.1415 0 12.5 0ZM15.8875 14.1125C16.0047 14.2287 16.0977 14.367 16.1611 14.5193C16.2246 14.6716 16.2572 14.835 16.2572 15C16.2572 15.165 16.2246 15.3284 16.1611 15.4807C16.0977 15.633 16.0047 15.7713 15.8875 15.8875C15.7713 16.0047 15.633 16.0976 15.4807 16.1611C15.3284 16.2246 15.165 16.2572 15 16.2572C14.835 16.2572 14.6716 16.2246 14.5193 16.1611C14.367 16.0976 14.2287 16.0047 14.1125 15.8875L12.5 14.2625L10.8875 15.8875C10.7713 16.0047 10.633 16.0976 10.4807 16.1611C10.3284 16.2246 10.165 16.2572 10 16.2572C9.83499 16.2572 9.67161 16.2246 9.51928 16.1611C9.36696 16.0976 9.22871 16.0047 9.1125 15.8875C8.99534 15.7713 8.90235 15.633 8.83889 15.4807C8.77543 15.3284 8.74276 15.165 8.74276 15C8.74276 14.835 8.77543 14.6716 8.83889 14.5193C8.90235 14.367 8.99534 14.2287 9.1125 14.1125L10.7375 12.5L9.1125 10.8875C8.87712 10.6521 8.74489 10.3329 8.74489 10C8.74489 9.66712 8.87712 9.34788 9.1125 9.1125C9.34788 8.87712 9.66713 8.74488 10 8.74488C10.3329 8.74488 10.6521 8.87712 10.8875 9.1125L12.5 10.7375L14.1125 9.1125C14.3479 8.87712 14.6671 8.74488 15 8.74488C15.3329 8.74488 15.6521 8.87712 15.8875 9.1125C16.1229 9.34788 16.2551 9.66712 16.2551 10C16.2551 10.3329 16.1229 10.6521 15.8875 10.8875L14.2625 12.5L15.8875 14.1125Z"
                />
              </svg>
              {{ helper.button.fermer_le_panier | translate }}
            </button>
          </div>
          <div
            class="livraison-offerte-mob"
            *ngIf="
              offer_service.delivery_offers &&
              offer_service.delivery_offers.length > 0
            "
          >
            <p *ngFor="let offer_message of offer_service.delivery_offers">
              {{ offer_message }}
            </p>
          </div>
          <!-- <div class="moa-mobile" *ngIf="(offer_service.cart_offer_message ? (helper.common_data._user_cart.cart_data.total_cart_amount-offer_service.cart_offer_value) : helper.common_data._user_cart.cart_data.total_cart_amount) < current_store.min_order_price">
                        <p class="moa">
                            <span>{{helper.text.moa | translate}} {{delivery_currency}} {{current_store.min_order_price}}</span>
                        </p>
                    </div> -->
          <div
            class="cart-product-list"
            *ngIf="
              helper.common_data._user_cart.cart_data.is_catering ==
              helper.common_data.cart_data.is_catering
            "
          >
            <ng-container
              *ngFor="
                let cart_product of helper.common_data._user_cart.cart_data
                  .cart;
                let product_index = index
              "
            >
              <div
                class="c-p-list-box"
                *ngFor="
                  let cart_item of cart_product.items;
                  let item_index = index
                "
              >
                <div class="c-product-title d-flex align-items-center">
                  <h3>{{ cart_item.item_name }}</h3>
                  <div class="qty-box d-flex align-items-center ml-auto">
                    <button
                      class="primary-btn dec"
                      (click)="cart_decrease_qty(product_index, item_index)"
                    >
                      -
                    </button>
                    <input
                      type="text"
                      class="form-control"
                      value="{{ cart_item.quantity }}"
                      readonly
                    />
                    <button
                      class="primary-btn inc"
                      (click)="cart_increase_qty(product_index, item_index)"
                    >
                      +
                    </button>
                  </div>
                </div>
                <div
                  class="c-pro-dec"
                  id="{{ cart_item.item_id + item_index }}"
                  [class.c-pro-dec-all]="cart_item.is_display_all"
                >
                  <p>
                    <span
                      *ngIf="
                        offer_service.check_buy_one_get_one(cart_item) &&
                        cart_item.is_buy_one_get_one
                      "
                    >
                      {{ helper.title.promotion_gratuit | translate }}
                      <span *ngIf="cart_item.specifications.length > 0">,</span>
                    </span>
                  </p>
                  <ng-container
                    *ngFor="
                      let specification of cart_item.specifications;
                      let specification_last = last
                    "
                  >
                    <ng-container>
                      <p
                        *ngFor="
                          let sp of specification.list;
                          let sp_last = last
                        "
                      >
                        <span>
                          {{ sp.name }}
                          <span>,</span>
                        </span>
                      </p>
                    </ng-container>
                  </ng-container>
                  <!-- <ng-container *ngFor="let formule of cart_item.formule_list; let specification_last=last;">
                                        <p>
                                            <b>
                                            Formule: {{formule.name}}
                                                <span>,</span>
                                            </b>
                                        </p>
                                        <ng-container *ngFor="let specification of cart_item.specifications; let specification_last=last;">
                                            <ng-container *ngIf="specification.formule_id==formule.formule_id">
                                                <p *ngFor="let sp of specification.list;let sp_last=last;">
                                                    <span>
                                                    {{sp.name}}
                                                        <span>,</span>
                                                    </span>
                                                </p>
                                            </ng-container>
                                        </ng-container>
                                    </ng-container> -->
                  <p *ngIf="cart_item.note_for_item">
                    <span>{{ cart_item.note_for_item }}</span>
                  </p>
                </div>
                <a
                  class="link-btn"
                  (click)="cart_item.is_display_all = true"
                  *ngIf="
                    !cart_item.is_display_all &&
                    check_button(cart_item.item_id + item_index)
                  "
                  >{{ helper.button.voir_plus | translate }}</a
                >
                <a
                  class="link-btn"
                  (click)="cart_item.is_display_all = false"
                  *ngIf="cart_item.is_display_all"
                  >{{ helper.button.voir_minus | translate }}</a
                >
                <div class="c-pro-tag d-flex align-items-start">
                  <div class="product-tag d-flex align-items-center">
                    <span
                      (click)="
                        open_edit_item_modal(
                          ProductItem,
                          cart_item,
                          product_index,
                          item_index
                        )
                      "
                      >{{ helper.title.modifier | translate }}</span
                    >
                    <span
                      (click)="remove_from_cart(product_index, item_index)"
                      >{{ helper.title.supprimer | translate }}</span
                    >
                  </div>
                  <div class="c-product-price ml-auto">
                    <span
                      >{{ delivery_currency }}
                      {{
                        (
                          cart_item.total_item_and_specification_price -
                          (cart_item.offer_price ? cart_item.offer_price : 0)
                        ).toFixed(2)
                      }}</span
                    >
                  </div>
                </div>
              </div>
            </ng-container>
            <!-- <div class="c-p-list-box">
                            <div class="c-product-title d-flex align-items-start">
                                <h3>1x Cheese Burger du Chef</h3>
                                <div class="qty-box d-flex align-items-center ml-auto">
                                    <button class="primary-btn dec">-</button>
                                    <input type="text" class="form-control" value="1">
                                    <button class="primary-btn inc">+</button>
                                </div>
                            </div>
                            <div class="c-pro-dec">
                                <p>Sans tomates,
                                    supplément cheddar,
                                    Souhaitez-vous profitez de 1+1 gratuit ? Non,
                                </p>
                            </div>
                            <a href="" class="link-btn">{{helper.button.voir_plus | translate}}</a>
                            <div class="c-pro-tag d-flex align-items-start">
                                <div class="product-tag d-flex align-items-center">
                                    <span>{{helper.title.modifier | translate}}</span>
                                    <span>{{helper.title.supprimer | translate}}</span>
                                </div>
                                <div class="c-product-price ml-auto">
                                    <span>{{delivery_currency}} 22.00</span>
                                </div>
                            </div>
                        </div>
                        <div class="c-p-list-box">
                            <div class="c-product-title d-flex align-items-start">
                                <h3>1x Cheese Burger du Chef</h3>
                                <div class="qty-box d-flex align-items-center ml-auto">
                                    <button class="primary-btn dec">-</button>
                                    <input type="text" class="form-control" value="1">
                                    <button class="primary-btn inc">+</button>
                                </div>
                            </div>
                            <div class="c-pro-dec">
                                <p>Sans tomates,
                                    supplément cheddar,
                                    Souhaitez-vous profitez de 1+1 gratuit ? Non,
                                </p>
                            </div>
                            <a href="" class="link-btn">{{helper.button.voir_plus | translate}}</a>
                            <div class="c-pro-tag d-flex align-items-start">
                                <div class="product-tag d-flex align-items-center">
                                    <span>{{helper.title.modifier | translate}}</span>
                                    <span>{{helper.title.supprimer | translate}}</span>
                                </div>
                                <div class="c-product-price ml-auto">
                                    <span>{{delivery_currency}} 22.00</span>
                                </div>
                            </div>
                        </div>
                        <div class="c-p-list-box">
                            <div class="c-product-title d-flex align-items-start">
                                <h3>1x Cheese Burger du Chef</h3>
                                <div class="qty-box d-flex align-items-center ml-auto">
                                    <button class="primary-btn dec">-</button>
                                    <input type="text" class="form-control" value="1">
                                    <button class="primary-btn inc">+</button>
                                </div>
                            </div>
                            <div class="c-pro-dec">
                                <p>Sans tomates,
                                    supplément cheddar,
                                    Souhaitez-vous profitez de 1+1 gratuit ? Non,
                                </p>
                            </div>
                            <a href="" class="link-btn">{{helper.button.voir_plus | translate}}</a>
                            <div class="c-pro-tag d-flex align-items-start">
                                <div class="product-tag d-flex align-items-center">
                                    <span>{{helper.title.modifier | translate}}</span>
                                    <span>{{helper.title.supprimer | translate}}</span>
                                </div>
                                <div class="c-product-price ml-auto">
                                    <span>{{delivery_currency}} 22.00</span>
                                </div>
                            </div>
                        </div> -->
          </div>
          <div
            class="moa-mobile"
            *ngIf="
              helper.common_data._user_cart.cart_data.total_cart_amount <
              helper.common_data._user_cart.cart_data.min_order_price
            "
          >
            <p class="moa">
              <span
                >{{ helper.text.moa | translate }} {{ delivery_currency }}
                {{
                  helper.common_data._user_cart.cart_data.min_order_price
                }}</span
              >
            </p>
          </div>
          <div
            class="empty-cart d-flex align-items-center justify-content-center"
            *ngIf="helper.common_data._user_cart.cart_data.cart.length == 0"
          >
            <div class="e-c-icon">
              <svg
                width="33"
                height="33"
                viewBox="0 0 33 33"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19.6875 10.0312C19.6875 9.74117 19.5723 9.46297 19.3671 9.25785C19.162 9.05273 18.8838 8.9375 18.5938 8.9375C18.3037 8.9375 18.0255 9.05273 17.8204 9.25785C17.6152 9.46297 17.5 9.74117 17.5 10.0312V13.3125H14.2188C13.9287 13.3125 13.6505 13.4277 13.4454 13.6329C13.2402 13.838 13.125 14.1162 13.125 14.4062C13.125 14.6963 13.2402 14.9745 13.4454 15.1796C13.6505 15.3848 13.9287 15.5 14.2188 15.5H17.5V18.7812C17.5 19.0713 17.6152 19.3495 17.8204 19.5546C18.0255 19.7598 18.3037 19.875 18.5938 19.875C18.8838 19.875 19.162 19.7598 19.3671 19.5546C19.5723 19.3495 19.6875 19.0713 19.6875 18.7812V15.5H22.9688C23.2588 15.5 23.537 15.3848 23.7421 15.1796C23.9473 14.9745 24.0625 14.6963 24.0625 14.4062C24.0625 14.1162 23.9473 13.838 23.7421 13.6329C23.537 13.4277 23.2588 13.3125 22.9688 13.3125H19.6875V10.0312Z"
                />
                <path
                  d="M1.09375 0.1875C0.803669 0.1875 0.52547 0.302734 0.320352 0.507852C0.115234 0.71297 0 0.991169 0 1.28125C0 1.57133 0.115234 1.84953 0.320352 2.05465C0.52547 2.25977 0.803669 2.375 1.09375 2.375H3.52188L4.39906 5.89031L7.67594 23.3575C7.72286 23.6081 7.85587 23.8345 8.05199 23.9975C8.24811 24.1604 8.49501 24.2498 8.75 24.25H10.9375C9.77718 24.25 8.66438 24.7109 7.84391 25.5314C7.02344 26.3519 6.5625 27.4647 6.5625 28.625C6.5625 29.7853 7.02344 30.8981 7.84391 31.7186C8.66438 32.5391 9.77718 33 10.9375 33C12.0978 33 13.2106 32.5391 14.0311 31.7186C14.8516 30.8981 15.3125 29.7853 15.3125 28.625C15.3125 27.4647 14.8516 26.3519 14.0311 25.5314C13.2106 24.7109 12.0978 24.25 10.9375 24.25H26.25C25.0897 24.25 23.9769 24.7109 23.1564 25.5314C22.3359 26.3519 21.875 27.4647 21.875 28.625C21.875 29.7853 22.3359 30.8981 23.1564 31.7186C23.9769 32.5391 25.0897 33 26.25 33C27.4103 33 28.5231 32.5391 29.3436 31.7186C30.1641 30.8981 30.625 29.7853 30.625 28.625C30.625 27.4647 30.1641 26.3519 29.3436 25.5314C28.5231 24.7109 27.4103 24.25 26.25 24.25H28.4375C28.6925 24.2498 28.9394 24.1604 29.1355 23.9975C29.3316 23.8345 29.4646 23.6081 29.5116 23.3575L32.7928 5.8575C32.8224 5.69964 32.8168 5.53722 32.7765 5.38176C32.7362 5.2263 32.6621 5.08162 32.5596 4.95801C32.4571 4.83439 32.3286 4.73487 32.1833 4.66652C32.0379 4.59816 31.8793 4.56265 31.7188 4.5625H6.32188L5.43594 1.01656C5.3769 0.77984 5.2404 0.569654 5.04816 0.419429C4.85592 0.269205 4.61897 0.187567 4.375 0.1875H1.09375ZM9.65781 22.0625L6.78562 6.75H30.4019L27.5297 22.0625H9.65781ZM13.125 28.625C13.125 29.2052 12.8945 29.7616 12.4843 30.1718C12.0741 30.582 11.5177 30.8125 10.9375 30.8125C10.3573 30.8125 9.80094 30.582 9.3907 30.1718C8.98047 29.7616 8.75 29.2052 8.75 28.625C8.75 28.0448 8.98047 27.4884 9.3907 27.0782C9.80094 26.668 10.3573 26.4375 10.9375 26.4375C11.5177 26.4375 12.0741 26.668 12.4843 27.0782C12.8945 27.4884 13.125 28.0448 13.125 28.625ZM28.4375 28.625C28.4375 29.2052 28.207 29.7616 27.7968 30.1718C27.3866 30.582 26.8302 30.8125 26.25 30.8125C25.6698 30.8125 25.1134 30.582 24.7032 30.1718C24.293 29.7616 24.0625 29.2052 24.0625 28.625C24.0625 28.0448 24.293 27.4884 24.7032 27.0782C25.1134 26.668 25.6698 26.4375 26.25 26.4375C26.8302 26.4375 27.3866 26.668 27.7968 27.0782C28.207 27.4884 28.4375 28.0448 28.4375 28.625Z"
                />
              </svg>
            </div>
            <div class="e-c-text">
              <span>{{ helper.text.empty_cart_text | translate }}</span>
            </div>
          </div>
        </div>
        <div class="c-drop-footer">
          <p
            *ngIf="
              offer_service.delivery_offers &&
              offer_service.delivery_offers.length > 0
            "
          >
            <span *ngFor="let offer_message of offer_service.delivery_offers">{{
              offer_message
            }}</span>
          </p>
          <p
            class="moa"
            *ngIf="
              helper.common_data._user_cart.cart_data.total_cart_amount <
              helper.common_data._user_cart.cart_data.min_order_price
            "
          >
            <span
              >{{ helper.text.moa | translate }} {{ delivery_currency }}
              {{
                helper.common_data._user_cart.cart_data.min_order_price
              }}</span
            >
          </p>
          <div class="commander-btn-p">
            <button
              class="primary-btn"
              [disabled]="
                helper.common_data._user_cart.cart_data.cart.length == 0 ||
                helper.common_data._user_cart.cart_data.total_cart_amount <
                  helper.common_data._user_cart.cart_data.min_order_price
              "
              [class.disabled]="
                helper.common_data._user_cart.cart_data.cart.length == 0 ||
                helper.common_data._user_cart.cart_data.total_cart_amount <
                  helper.common_data._user_cart.cart_data.min_order_price
              "
              (click)="go_to_checkout()"
            >
              {{ helper.button.cart_d_btn | translate }}
              <span
                >{{ delivery_currency
                }}{{
                  helper.common_data._user_cart.cart_data.total_cart_amount.toFixed(
                    2
                  )
                }}</span
              >
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="shop-footer"
      [class.shop-footer-cart-open]="is_show_cart"
      *ngIf="offer_service.is_show_cart_offer"
    >
      <div
        class="footer-close"
        (click)="offer_service.is_show_cart_offer = false"
      >
        <span>
          <svg
            width="34"
            height="34"
            viewBox="0 0 34 34"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.537 0C13.2663 0 10.069 0.969877 7.34954 2.78698C4.63004 4.60409 2.51046 7.18681 1.25881 10.2086C0.00716521 13.2303 -0.320322 16.5553 0.317761 19.7632C0.955844 22.971 2.53084 25.9177 4.84358 28.2304C7.15632 30.5431 10.1029 32.1181 13.3108 32.7562C16.5186 33.3943 19.8437 33.0668 22.8654 31.8152C25.8872 30.5635 28.4699 28.4439 30.287 25.7244C32.1041 23.0049 33.074 19.8077 33.074 16.537C33.074 14.3653 32.6462 12.2149 31.8152 10.2086C30.9841 8.20219 29.766 6.37917 28.2304 4.84357C26.6948 3.30797 24.8718 2.08986 22.8654 1.2588C20.8591 0.427742 18.7087 0 16.537 0ZM21.0185 18.6703C21.1735 18.824 21.2965 19.0069 21.3805 19.2084C21.4645 19.4099 21.5077 19.6261 21.5077 19.8444C21.5077 20.0627 21.4645 20.2788 21.3805 20.4804C21.2965 20.6819 21.1735 20.8648 21.0185 21.0185C20.8648 21.1735 20.6819 21.2965 20.4804 21.3805C20.2788 21.4644 20.0627 21.5077 19.8444 21.5077C19.6261 21.5077 19.4099 21.4644 19.2084 21.3805C19.0069 21.2965 18.824 21.1735 18.6703 21.0185L16.537 18.8687L14.4037 21.0185C14.25 21.1735 14.0671 21.2965 13.8656 21.3805C13.6641 21.4644 13.4479 21.5077 13.2296 21.5077C13.0113 21.5077 12.7951 21.4644 12.5936 21.3805C12.3921 21.2965 12.2092 21.1735 12.0555 21.0185C11.9005 20.8648 11.7774 20.6819 11.6935 20.4804C11.6095 20.2788 11.5663 20.0627 11.5663 19.8444C11.5663 19.6261 11.6095 19.4099 11.6935 19.2084C11.7774 19.0069 11.9005 18.824 12.0555 18.6703L14.2053 16.537L12.0555 14.4037C11.7441 14.0923 11.5691 13.67 11.5691 13.2296C11.5691 12.7892 11.7441 12.3669 12.0555 12.0555C12.3669 11.7441 12.7892 11.5691 13.2296 11.5691C13.67 11.5691 14.0923 11.7441 14.4037 12.0555L16.537 14.2053L18.6703 12.0555C18.9817 11.7441 19.404 11.5691 19.8444 11.5691C20.2848 11.5691 20.7071 11.7441 21.0185 12.0555C21.3299 12.3669 21.5049 12.7892 21.5049 13.2296C21.5049 13.67 21.3299 14.0923 21.0185 14.4037L18.8687 16.537L21.0185 18.6703Z"
            />
          </svg>
        </span>
      </div>
      <p *ngIf="offer_service.cart_offer_error2">
        {{ offer_service.cart_offer_error2 }}
      </p>
      <p *ngIf="offer_service.cart_offer_message">
        {{ offer_service.cart_offer_message }}
      </p>
      <div class="progress-bar-top" *ngIf="offer_service.cart_offer_error2">
        <ngb-progressbar
          type="warning"
          [value]="offer_service.cart_offer_progress_bar"
          height="14px"
        ></ngb-progressbar>
      </div>
      <div
        class="progress-bar-top"
        *ngIf="
          offer_service.cart_offer_message &&
          offer_service.cart_offer_progress_bar >= 0
        "
      >
        <ngb-progressbar
          type="warning"
          [value]="offer_service.cart_offer_progress_bar"
          height="14px"
        ></ngb-progressbar>
      </div>
    </div>
    <div class="menu-cart-btn">
      <button
        class="primary-btn btn-mob"
        *ngIf="!is_show_cart"
        (click)="show_mobile_cart()"
      >
        <label>
          {{ helper.button.voir_votre_panier | translate }}
          <span
            >{{ delivery_currency }}
            {{
              helper.common_data._user_cart.cart_data.total_cart_amount.toFixed(
                2
              )
            }}</span
          >
        </label>
        <svg
          width="16"
          height="14"
          viewBox="0 0 16 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_1842_9206)">
            <path
              d="M14.4407 8.23916L15.7333 2.55168C15.8267 2.14103 15.5145 1.74999 15.0934 1.74999H4.35333L4.1027 0.524725C4.04024 0.219323 3.77151 0 3.45976 0H0.656247C0.293807 0 0 0.293807 0 0.656247V1.09375C0 1.45619 0.293807 1.74999 0.656247 1.74999H2.5671L4.48794 11.1408C4.0284 11.405 3.71874 11.9006 3.71874 12.4687C3.71874 13.3144 4.4043 13.9999 5.24998 13.9999C6.09566 13.9999 6.78122 13.3144 6.78122 12.4687C6.78122 12.0401 6.60494 11.6529 6.32119 11.375H12.0537C11.77 11.6529 11.5937 12.0401 11.5937 12.4687C11.5937 13.3144 12.2793 13.9999 13.125 13.9999C13.9706 13.9999 14.6562 13.3144 14.6562 12.4687C14.6562 11.8624 14.3038 11.3385 13.7927 11.0904L13.9436 10.4267C14.0369 10.016 13.7248 9.62496 13.3036 9.62496H5.96411L5.78515 8.74997H13.8008C14.1072 8.74997 14.3728 8.53794 14.4407 8.23916Z"
            />
          </g>
          <defs>
            <clipPath id="clip0_1842_9206">
              <rect width="15.7499" height="13.9999" />
            </clipPath>
          </defs>
        </svg>
      </button>
      <button
        class="primary-btn btn-mob"
        *ngIf="is_show_cart"
        (click)="go_to_checkout()"
      >
        <label class="d-flex align-items-center">
          {{ helper.button.cart_d_btn | translate }}
          <span class="ml-auto">
            <span
              >{{ delivery_currency
              }}{{
                helper.common_data._user_cart.cart_data.total_cart_amount.toFixed(
                  2
                )
              }}</span
            >
          </span>
        </label>
      </button>
    </div>
  </div>
</div>

<!-- Re order popup start  -->

<ng-template #ReOrder let-modal>
  <!-- <button type="button" class="close pull-right" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true"><svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.641964 4.44674C0.27079 4.07556 0.0852035 3.64252 0.0852036 3.14762C0.0852039 2.65272 0.270791 2.21969 0.641965 1.84851C1.01314 1.47734 1.43844 1.29948 1.91788 1.31495C2.39731 1.33042 2.82261 1.52374 3.19379 1.89491L12.6355 11.3367C13.0067 11.7078 13.1923 12.1409 13.1923 12.6358C13.2078 13.1152 13.0299 13.5405 12.6587 13.9117C12.2876 14.2829 11.8545 14.4684 11.3596 14.4684C10.8802 14.453 10.4549 14.2597 10.0837 13.8885L0.641964 4.44674ZM0.804354 13.6565C0.371317 13.2235 0.147065 12.7208 0.1316 12.1486C0.1316 11.5918 0.348119 11.0969 0.781156 10.6639L9.82853 1.61653C10.2616 1.18349 10.7642 0.974707 11.3364 0.990173C11.9087 1.00564 12.4113 1.22989 12.8443 1.66293C13.2928 2.11143 13.5093 2.60633 13.4939 3.14763C13.4939 3.70439 13.2774 4.19929 12.8443 4.63232L3.79695 13.6797C3.36391 14.1127 2.86901 14.3293 2.31225 14.3293C1.75549 14.3293 1.25286 14.105 0.804354 13.6565Z"/>
            </svg></span>
    </button> -->
  <button
    type="button"
    class="close with-name pull-right d-flex align-items-center"
    aria-label="Close"
    (click)="modal.dismiss('Cross click')"
  >
    <span aria-hidden="true">
      <label>{{ helper.button.fermer | translate }}</label>
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15 3C12.6266 3 10.3066 3.70379 8.33316 5.02236C6.35977 6.34094 4.8217 8.21508 3.91345 10.4078C3.0052 12.6005 2.76756 15.0133 3.23058 17.3411C3.6936 19.6689 4.83649 21.807 6.51472 23.4853C8.19295 25.1635 10.3311 26.3064 12.6589 26.7694C14.9867 27.2324 17.3995 26.9948 19.5922 26.0865C21.7849 25.1783 23.6591 23.6402 24.9776 21.6668C26.2962 19.6934 27 17.3734 27 15C27 13.4241 26.6896 11.8637 26.0866 10.4078C25.4835 8.95189 24.5996 7.62902 23.4853 6.51472C22.371 5.40041 21.0481 4.5165 19.5922 3.91345C18.1363 3.31039 16.5759 3 15 3ZM18.252 16.548C18.3645 16.6596 18.4538 16.7923 18.5147 16.9385C18.5756 17.0847 18.607 17.2416 18.607 17.4C18.607 17.5584 18.5756 17.7153 18.5147 17.8615C18.4538 18.0077 18.3645 18.1404 18.252 18.252C18.1404 18.3645 18.0077 18.4537 17.8615 18.5147C17.7153 18.5756 17.5584 18.607 17.4 18.607C17.2416 18.607 17.0847 18.5756 16.9385 18.5147C16.7923 18.4537 16.6596 18.3645 16.548 18.252L15 16.692L13.452 18.252C13.3404 18.3645 13.2077 18.4537 13.0615 18.5147C12.9153 18.5756 12.7584 18.607 12.6 18.607C12.4416 18.607 12.2847 18.5756 12.1385 18.5147C11.9923 18.4537 11.8596 18.3645 11.748 18.252C11.6355 18.1404 11.5463 18.0077 11.4853 17.8615C11.4244 17.7153 11.393 17.5584 11.393 17.4C11.393 17.2416 11.4244 17.0847 11.4853 16.9385C11.5463 16.7923 11.6355 16.6596 11.748 16.548L13.308 15L11.748 13.452C11.522 13.226 11.3951 12.9196 11.3951 12.6C11.3951 12.2804 11.522 11.974 11.748 11.748C11.974 11.522 12.2804 11.3951 12.6 11.3951C12.9196 11.3951 13.226 11.522 13.452 11.748L15 13.308L16.548 11.748C16.774 11.522 17.0804 11.3951 17.4 11.3951C17.7196 11.3951 18.026 11.522 18.252 11.748C18.478 11.974 18.6049 12.2804 18.6049 12.6C18.6049 12.9196 18.478 13.226 18.252 13.452L16.692 15L18.252 16.548Z"
        />
      </svg>
    </span>
  </button>
  <div class="modal-header justify-content-center no-header">
    <h2 *ngIf="order_history.length > 0">
      {{ helper.title.vos_commandes_deja_passees | translate }}
    </h2>
    <h2 *ngIf="order_history.length == 0">
      {{ helper.title.vos_commandes_deja_passees1 | translate }}
    </h2>
  </div>
  <div class="modal-body">
    <div class="modal-body-wrp">
      <div class="re-order-list">
        <div class="re-order-list-wrp">
          <div class="r-o-list-box" *ngFor="let order of order_history">
            <div class="order-create-detail d-flex align-items-start">
              <div class="o-c-d-left">
                <span
                  >Commande crée le
                  {{
                    order.created_at
                      | date : "dd/MM/yy à " + helper.website_data.time_format
                  }}</span
                >
                <div class="alert-box" *ngIf="!order.is_full_order_available">
                  <p>
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M14.9332 13.375L8.43321 2.125C8.33633 1.95781 8.16915 1.875 8.0004 1.875C7.83165 1.875 7.6629 1.95781 7.56758 2.125L1.06758 13.375C0.875396 13.7094 1.11602 14.125 1.5004 14.125H14.5004C14.8848 14.125 15.1254 13.7094 14.9332 13.375ZM7.5004 6.5C7.5004 6.43125 7.55665 6.375 7.6254 6.375H8.3754C8.44415 6.375 8.5004 6.43125 8.5004 6.5V9.375C8.5004 9.44375 8.44415 9.5 8.3754 9.5H7.6254C7.55665 9.5 7.5004 9.44375 7.5004 9.375V6.5ZM8.0004 12C7.80414 11.996 7.61726 11.9152 7.47988 11.775C7.3425 11.6348 7.26555 11.4463 7.26555 11.25C7.26555 11.0537 7.3425 10.8652 7.47988 10.725C7.61726 10.5848 7.80414 10.504 8.0004 10.5C8.19666 10.504 8.38353 10.5848 8.52091 10.725C8.6583 10.8652 8.73524 11.0537 8.73524 11.25C8.73524 11.4463 8.6583 11.6348 8.52091 11.775C8.38353 11.9152 8.19666 11.996 8.0004 12Z"
                      />
                    </svg>
                    {{ helper.error_message.order_alert_text1 | translate }}
                  </p>
                </div>
              </div>
              <div class="o-c-d-right ml-auto">
                <button
                  class="primary-btn"
                  (click)="reorder(order.cart_detail)"
                  *ngIf="order.is_full_order_available"
                >
                  {{ helper.button.available_product1 | translate }}
                </button>
                <button
                  class="primary-btn"
                  (click)="reorder(order.cart_detail)"
                  *ngIf="!order.is_full_order_available"
                >
                  {{ helper.button.available_product | translate }}
                </button>
              </div>
            </div>

            <ng-container
              *ngFor="let product of order.cart_detail.order_details"
            >
              <div class="r-oder-details" *ngFor="let item of product.items">
                <div class="r-o-product-name" [class.red]="!item.is_available">
                  <h3>{{ item.item_name }}</h3>
                  <ng-container *ngIf="item.is_available">
                    <div class="r-o-desc">
                      <ng-container
                        *ngFor="
                          let specification of item.specifications;
                          let specification_last = last
                        "
                      >
                        <span
                          *ngFor="
                            let sp of specification.list;
                            let sp_last = last
                          "
                          [class.red]="!sp.is_available"
                          >{{ sp.name }}
                          <span *ngIf="!sp_last || !specification_last">,</span>
                        </span>
                      </ng-container>
                    </div>
                  </ng-container>
                </div>
              </div>
            </ng-container>
            <div class="r-o-total">
              <span>{{ delivery_currency }} {{ order.total_order_price }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="modal-footer">
        <div class="modal-footer-wrp d-flex align-items-center justify-content-center">
          <div class="popup-footer-btn">
              <button class="primary-btn">{{helper.button.fermer | translate}}</button>
          </div>
        </div>
    </div> -->
</ng-template>
<app-login-register-modal
  #AccountPopup
  [is_second_text]="is_second_text"
  [login_header_text]="login_header_text"
  [is_register_button]="is_register_button"
></app-login-register-modal>

<!-- Re order popup end  -->

<!-- Product item popup start  -->

<ng-template #ProductItem let-modal>
  <div class="modal-main">
    <button
      type="button"
      class="close with-name pull-right d-flex align-items-center"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    >
      <span aria-hidden="true">
        <label>{{ helper.button.fermer | translate }}</label>
        <svg
          width="30"
          height="30"
          viewBox="0 0 30 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15 3C12.6266 3 10.3066 3.70379 8.33316 5.02236C6.35977 6.34094 4.8217 8.21508 3.91345 10.4078C3.0052 12.6005 2.76756 15.0133 3.23058 17.3411C3.6936 19.6689 4.83649 21.807 6.51472 23.4853C8.19295 25.1635 10.3311 26.3064 12.6589 26.7694C14.9867 27.2324 17.3995 26.9948 19.5922 26.0865C21.7849 25.1783 23.6591 23.6402 24.9776 21.6668C26.2962 19.6934 27 17.3734 27 15C27 13.4241 26.6896 11.8637 26.0866 10.4078C25.4835 8.95189 24.5996 7.62902 23.4853 6.51472C22.371 5.40041 21.0481 4.5165 19.5922 3.91345C18.1363 3.31039 16.5759 3 15 3ZM18.252 16.548C18.3645 16.6596 18.4538 16.7923 18.5147 16.9385C18.5756 17.0847 18.607 17.2416 18.607 17.4C18.607 17.5584 18.5756 17.7153 18.5147 17.8615C18.4538 18.0077 18.3645 18.1404 18.252 18.252C18.1404 18.3645 18.0077 18.4537 17.8615 18.5147C17.7153 18.5756 17.5584 18.607 17.4 18.607C17.2416 18.607 17.0847 18.5756 16.9385 18.5147C16.7923 18.4537 16.6596 18.3645 16.548 18.252L15 16.692L13.452 18.252C13.3404 18.3645 13.2077 18.4537 13.0615 18.5147C12.9153 18.5756 12.7584 18.607 12.6 18.607C12.4416 18.607 12.2847 18.5756 12.1385 18.5147C11.9923 18.4537 11.8596 18.3645 11.748 18.252C11.6355 18.1404 11.5463 18.0077 11.4853 17.8615C11.4244 17.7153 11.393 17.5584 11.393 17.4C11.393 17.2416 11.4244 17.0847 11.4853 16.9385C11.5463 16.7923 11.6355 16.6596 11.748 16.548L13.308 15L11.748 13.452C11.522 13.226 11.3951 12.9196 11.3951 12.6C11.3951 12.2804 11.522 11.974 11.748 11.748C11.974 11.522 12.2804 11.3951 12.6 11.3951C12.9196 11.3951 13.226 11.522 13.452 11.748L15 13.308L16.548 11.748C16.774 11.522 17.0804 11.3951 17.4 11.3951C17.7196 11.3951 18.026 11.522 18.252 11.748C18.478 11.974 18.6049 12.2804 18.6049 12.6C18.6049 12.9196 18.478 13.226 18.252 13.452L16.692 15L18.252 16.548Z"
          />
        </svg>
      </span>
    </button>
    <!-- <div class="modal-header justify-content-center no-header">

        </div> -->
    <div class="modal-body">
      <div class="modal-body-wrp">
        <div class="product-item-main">
          <div class="p-i-wrp">
            <div class="p-i-content">
              <div
                class="p-i-img"
                *ngIf="current_item.image_url && current_item.image_url[0]"
              >
                <img
                  (error)="(helper.website_data.detail.site_logo)"
                  src="{{
                    current_item.image_url[0]
                      ? helper.get_image(current_item.image_url[0], 215, 425)
                      : helper.website_data.detail.site_logo
                  }}"
                />
                <div class="agrandir-img-btn">
                  <button
                    class="primary-btn"
                    (click)="openModal2(ProductImagePreview)"
                  >
                    {{ helper.button.agrandir_image | translate }}
                    <svg
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M3.2475 8.09375C3.33636 8.01095 3.45389 7.96587 3.57533 7.96802C3.69676 7.97016 3.81263 8.01935 3.89851 8.10524C3.9844 8.19112 4.03359 8.30698 4.03573 8.42842C4.03788 8.54986 3.9928 8.66739 3.91 8.75625L1.97562 10.69H3.34375C3.45702 10.69 3.56646 10.731 3.65183 10.8055C3.7372 10.8799 3.79272 10.9828 3.80813 11.095L3.8125 11.1587C3.8125 11.2831 3.76311 11.4023 3.67521 11.4902C3.5873 11.5781 3.46807 11.6275 3.34375 11.6275H0.84375C0.71943 11.6275 0.600201 11.5781 0.512294 11.4902C0.424386 11.4023 0.375 11.2831 0.375 11.1587V8.65875C0.375 8.53443 0.424386 8.4152 0.512294 8.32729C0.600201 8.23939 0.71943 8.19 0.84375 8.19C0.96807 8.19 1.0873 8.23939 1.17521 8.32729C1.26311 8.4152 1.3125 8.53443 1.3125 8.65875V10.0275L3.2475 8.09375ZM8.65937 11.6275C8.53505 11.6275 8.41583 11.5781 8.32792 11.4902C8.24001 11.4023 8.19063 11.2831 8.19063 11.1587C8.19063 11.0344 8.24001 10.9152 8.32792 10.8273C8.41583 10.7394 8.53505 10.69 8.65937 10.69H10.0256L8.09375 8.75625C8.01436 8.67688 7.9661 8.57166 7.95772 8.45972C7.94935 8.34777 7.98143 8.23654 8.04813 8.14625L8.09375 8.09375C8.18164 8.00597 8.30078 7.95666 8.425 7.95666C8.54922 7.95666 8.66836 8.00597 8.75625 8.09375L10.6906 10.0287V8.65875C10.6906 8.54548 10.7317 8.43604 10.8061 8.35067C10.8806 8.2653 10.9834 8.20978 11.0956 8.19438L11.1594 8.19C11.2837 8.19 11.4029 8.23939 11.4908 8.32729C11.5787 8.4152 11.6281 8.53443 11.6281 8.65875V11.1587C11.6281 11.2831 11.5787 11.4023 11.4908 11.4902C11.4029 11.5781 11.2837 11.6275 11.1594 11.6275H8.65937ZM3.34375 0.375C3.46807 0.375 3.5873 0.424386 3.67521 0.512294C3.76311 0.600201 3.8125 0.71943 3.8125 0.84375C3.8125 0.96807 3.76311 1.0873 3.67521 1.17521C3.5873 1.26311 3.46807 1.3125 3.34375 1.3125H1.97688L3.91 3.24687C3.98929 3.32632 4.03744 3.43158 4.0457 3.54352C4.05396 3.65547 4.02178 3.76665 3.955 3.85687L3.90937 3.91C3.82148 3.99778 3.70234 4.04709 3.57812 4.04709C3.45391 4.04709 3.33477 3.99778 3.24687 3.91L1.3125 1.97313V3.34375C1.3125 3.45702 1.27147 3.56646 1.19702 3.65183C1.12257 3.7372 1.01972 3.79272 0.9075 3.80813L0.84375 3.8125C0.71943 3.8125 0.600201 3.76311 0.512294 3.67521C0.424386 3.5873 0.375 3.46807 0.375 3.34375V0.84375C0.375 0.71943 0.424386 0.600201 0.512294 0.512294C0.600201 0.424386 0.71943 0.375 0.84375 0.375H3.34375ZM11.1594 0.375C11.2837 0.375 11.4029 0.424386 11.4908 0.512294C11.5787 0.600201 11.6281 0.71943 11.6281 0.84375V3.34375C11.6281 3.46807 11.5787 3.5873 11.4908 3.67521C11.4029 3.76311 11.2837 3.8125 11.1594 3.8125C11.0351 3.8125 10.9158 3.76311 10.8279 3.67521C10.74 3.5873 10.6906 3.46807 10.6906 3.34375V1.97438L8.75625 3.90937C8.67688 3.98876 8.57166 4.03703 8.45972 4.0454C8.34777 4.05377 8.23654 4.0217 8.14625 3.955L8.09375 3.90937C8.00597 3.82148 7.95666 3.70234 7.95666 3.57812C7.95666 3.45391 8.00597 3.33477 8.09375 3.24687L10.0262 1.3125H8.65937C8.5461 1.3125 8.43666 1.27147 8.35129 1.19702C8.26593 1.12257 8.21041 1.01972 8.195 0.9075L8.19063 0.84375C8.19063 0.71943 8.24001 0.600201 8.32792 0.512294C8.41583 0.424386 8.53505 0.375 8.65937 0.375H11.1594Z"
                      />
                    </svg>
                  </button>
                </div>
              </div>
              <div class="p-i-name">
                <h3>{{ current_item.name }}</h3>
                <p>{{ current_item.details }}</p>
                <span
                  >{{ delivery_currency }}
                  {{
                    (
                      total -
                      (current_item.offer_price ? current_item.offer_price : 0)
                    ).toFixed(2)
                  }}</span
                >
              </div>
            </div>
            <div class="product-options-list-main">
              <div
                class="product-options-list"
                *ngIf="
                  current_item.formule_list &&
                  current_item.formule_list.length > 0
                "
              >
                <div class="p-options-box formule-box">
                  <div class="p-variant-list">
                    <div class="p-v-b d-flex align-items-center">
                      <label class="check_lb">
                        {{ current_item.name }}
                        <input
                          (change)="select_formule({})"
                          type="radio"
                          [checked]="!current_formule.formule_id"
                          class="ng-dirty ng-touched ng-valid"
                        />
                        <span
                          class="checkmark sign_in_checkmak"
                          [class.checked]="!current_formule.formule_id"
                        ></span>
                      </label>
                      <span class="p-v-price ml-auto"></span>
                    </div>
                  </div>
                </div>
                <div
                  class="p-options-box formule-box"
                  *ngFor="let formule of current_item.formule_list"
                >
                  <div class="p-variant-list">
                    <div class="p-v-b d-flex align-items-center">
                      <label class="check_lb">
                        {{ formule.name }}
                        <br />
                        <span
                          >{{ current_item.name }}
                          <ng-container
                            *ngFor="
                              let specification_group of current_item.specifications
                            "
                          >
                            <span
                              *ngIf="
                                specification_group.formule_id ==
                                formule.formule_id
                              "
                            >
                              + {{ specification_group.name }}</span
                            >
                          </ng-container>
                        </span>
                        <input
                          (change)="select_formule(formule)"
                          type="radio"
                          [checked]="
                            current_formule.formule_id == formule.formule_id
                          "
                          class="ng-dirty ng-touched ng-valid"
                        />
                        <span
                          class="checkmark sign_in_checkmak"
                          [class.checked]="
                            current_formule.formule_id == formule.formule_id
                          "
                        ></span>
                      </label>
                      <span class="p-v-price ml-auto"
                        >+ {{ delivery_currency }}
                        {{
                          (formule.price - current_item.price).toFixed(2)
                        }}</span
                      >
                    </div>
                    <!-- <div class="d-flex align-items-center">
                                        <span style="padding-left: 46px;">{{current_item.name}}
                                            <ng-container *ngFor="let specification_group of current_item.specifications;">
                                                <span *ngIf="specification_group.formule_id==formule.formule_id"> + {{specification_group.name}}</span>
                                            </ng-container>
                                        </span>
                                    </div> -->
                  </div>
                </div>
              </div>

              <div
                class="product-options-list"
                *ngIf="offer_service.check_buy_one_get_one(current_item)"
              >
                <div class="p-options-box">
                  <h4>
                    {{ helper.title.buy_one_get_one_offer | translate }} ⭐️
                  </h4>
                  <div class="p-variant-list">
                    <div class="p-v-b d-flex align-items-center">
                      <label class="check_lb">
                        {{ helper.title.oui | translate }}
                        <input
                          (change)="
                            offer_service.change_buy_one_get_one(
                              current_item,
                              true
                            )
                          "
                          type="radio"
                          [checked]="current_item.is_buy_one_get_one"
                          class="ng-dirty ng-touched ng-valid"
                        />
                        <span
                          class="checkmark sign_in_checkmak"
                          [class.checked]="current_item.is_buy_one_get_one"
                        ></span>
                      </label>
                      <span class="p-v-price ml-auto"
                        >{{ delivery_currency }} 0</span
                      >
                    </div>
                    <div class="p-v-b d-flex align-items-center">
                      <label class="check_lb">
                        {{ helper.title.non | translate }}
                        <input
                          (change)="
                            offer_service.change_buy_one_get_one(
                              current_item,
                              false
                            )
                          "
                          type="radio"
                          [checked]="!current_item.is_buy_one_get_one"
                          class="ng-dirty ng-touched ng-valid"
                        />
                        <span
                          class="checkmark sign_in_checkmak"
                          [class.checked]="!current_item.is_buy_one_get_one"
                        ></span>
                      </label>
                      <span class="p-v-price ml-auto"
                        >{{ delivery_currency }} 0</span
                      >
                    </div>
                  </div>
                </div>
              </div>
              <ng-container
                *ngFor="
                  let specification_group of current_item.specifications;
                  let specification_group_index = index
                "
              >
                <div
                  class="product-options-list"
                  *ngIf="
                    !specification_group.is_close &&
                    specification_group.formule_id &&
                    specification_group.formule_id == current_formule.formule_id
                  "
                  id="specification{{ specification_group.unique_id }}"
                >
                  <div class="p-options-box">
                    <h4
                      [class.red]="
                        specification_group.is_required &&
                        specification_group.is_disabled
                      "
                    >
                      {{ specification_group.name }}
                    </h4>
                    <span
                      [class.red]="
                        specification_group.is_required &&
                        specification_group.is_disabled
                      "
                    >
                      <span
                        [class.red]="
                          specification_group.is_required &&
                          specification_group.is_disabled
                        "
                        *ngIf="specification_group.min_selection > 0"
                      >
                        {{ specification_group.min_selection }}
                        {{ helper.title.mandatory_choice | translate }}
                      </span>
                      <span
                        [class.red]="
                          specification_group.is_required &&
                          specification_group.is_disabled
                        "
                        *ngIf="
                          specification_group.max_selection > 0 &&
                          specification_group.type == 2
                        "
                      >
                        <span
                          [class.red]="
                            specification_group.is_required &&
                            specification_group.is_disabled
                          "
                          *ngIf="specification_group.min_selection > 0"
                        >
                          /
                        </span>
                        {{ specification_group.max_selection }}
                        {{ helper.title.max_choice | translate }}
                      </span>
                    </span>
                    <div
                      class="p-variant-list"
                      [class.input-checkbox]="
                        specification_group.type == 2 ||
                        !specification_group.is_required
                      "
                    >
                      <ng-container
                        *ngFor="
                          let specification of specification_group.list;
                          let specification_index = index
                        "
                      >
                        <div
                          class="p-v-b d-flex align-items-center"
                          *ngIf="!specification.is_close"
                        >
                          <label class="check_lb">
                            {{ specification.name }}
                            <input
                              [disabled]="specification.is_close"
                              *ngIf="
                                specification_group.type == 1 &&
                                specification_group.is_required
                              "
                              (change)="
                                changeradio(
                                  $event,
                                  specification_group_index,
                                  specification_index
                                )
                              "
                              type="radio"
                              [checked]="specification.is_default_selected"
                              class="ng-dirty ng-touched ng-valid"
                            />
                            <input
                              [disabled]="specification.is_close"
                              *ngIf="
                                specification_group.type == 2 ||
                                !specification_group.is_required
                              "
                              (change)="
                                changecheckbox(
                                  $event,
                                  specification_group_index,
                                  specification_index
                                )
                              "
                              type="checkbox"
                              [checked]="specification.is_default_selected"
                              class="ng-dirty ng-touched ng-valid"
                            />
                            <!-- [disabled]="specification_group.default_selected_count==specification_group.max_selection && !specification.is_default_selected" -->
                            <span
                              class="checkmark sign_in_checkmak"
                              [class.checked]="
                                specification.is_default_selected
                              "
                            ></span>
                          </label>
                          <span class="p-v-price ml-auto"
                            >{{ delivery_currency }}
                            {{ specification.price.toFixed(2) }}</span
                          >
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </ng-container>
              <ng-container
                *ngFor="
                  let specification_group of current_item.specifications;
                  let specification_group_index = index
                "
              >
                <div
                  class="product-options-list"
                  *ngIf="
                    !specification_group.is_close &&
                    !specification_group.formule_id
                  "
                  id="specification{{ specification_group.unique_id }}"
                >
                  <div class="p-options-box">
                    <h4
                      [class.red]="
                        specification_group.is_required &&
                        specification_group.is_disabled
                      "
                    >
                      {{ specification_group.name }}
                    </h4>
                    <span
                      [class.red]="
                        specification_group.is_required &&
                        specification_group.is_disabled
                      "
                    >
                      <span
                        [class.red]="
                          specification_group.is_required &&
                          specification_group.is_disabled
                        "
                        *ngIf="specification_group.min_selection > 0"
                      >
                        {{ specification_group.min_selection }}
                        {{ helper.title.mandatory_choice | translate }}
                      </span>
                      <span
                        [class.red]="
                          specification_group.is_required &&
                          specification_group.is_disabled
                        "
                        *ngIf="
                          specification_group.max_selection > 0 &&
                          specification_group.type == 2
                        "
                      >
                        <span
                          [class.red]="
                            specification_group.is_required &&
                            specification_group.is_disabled
                          "
                          *ngIf="specification_group.min_selection > 0"
                        >
                          /
                        </span>
                        {{ specification_group.max_selection }}
                        {{ helper.title.max_choice | translate }}
                      </span>
                    </span>
                    <div
                      class="p-variant-list"
                      [class.input-checkbox]="
                        specification_group.type == 2 ||
                        !specification_group.is_required
                      "
                    >
                      <ng-container
                        *ngFor="
                          let specification of specification_group.list;
                          let specification_index = index
                        "
                      >
                        <div
                          class="p-v-b d-flex align-items-center"
                          *ngIf="!specification.is_close"
                        >
                          <label class="check_lb">
                            {{ specification.name }}
                            <input
                              [disabled]="specification.is_close"
                              *ngIf="
                                specification_group.type == 1 &&
                                specification_group.is_required
                              "
                              (change)="
                                changeradio(
                                  $event,
                                  specification_group_index,
                                  specification_index
                                )
                              "
                              type="radio"
                              [checked]="specification.is_default_selected"
                              class="ng-dirty ng-touched ng-valid"
                            />
                            <input
                              [disabled]="specification.is_close"
                              *ngIf="
                                specification_group.type == 2 ||
                                !specification_group.is_required
                              "
                              (change)="
                                changecheckbox(
                                  $event,
                                  specification_group_index,
                                  specification_index
                                )
                              "
                              type="checkbox"
                              [checked]="specification.is_default_selected"
                              class="ng-dirty ng-touched ng-valid"
                            />
                            <!-- [disabled]="specification_group.default_selected_count==specification_group.max_selection && !specification.is_default_selected" -->
                            <span
                              class="checkmark sign_in_checkmak"
                              [class.checked]="
                                specification.is_default_selected
                              "
                            ></span>
                          </label>
                          <span class="p-v-price ml-auto"
                            >{{ delivery_currency }}
                            {{ specification.price.toFixed(2) }}</span
                          >
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </ng-container>
              <!-- <div class="product-options-list">
                            <div class="p-options-box">
                                <h4 class="">Sauce</h4>
                                <span>1 choix obligatoire</span>
                                <div class="p-variant-list input-checkbox">
                                    <div class="p-v-b d-flex align-items-center">
                                        <label class="check_lb">
                                            Sauce pimentée
                                            <input name="terms" type="checkbox" class="ng-dirty ng-touched ng-valid">
                                            <span class="checkmark sign_in_checkmak"></span>
                                        </label>
                                        <span class="p-v-price ml-auto">CHF 2.90</span>
                                    </div>
                                    <div class="p-v-b d-flex align-items-center">
                                        <label class="check_lb">
                                            Sauce pimentée
                                            <input name="terms" type="checkbox" class="ng-dirty ng-touched ng-valid">
                                            <span class="checkmark sign_in_checkmak"></span>
                                        </label>
                                        <span class="p-v-price ml-auto">CHF 2.90</span>
                                    </div>
                                </div>
                            </div>
                        </div> -->
              <div class="product-options-list">
                <div class="p-options-box">
                  <div class="comment-trade">
                    <h4>
                      {{ helper.title.comment_trade1 | translate }}
                      <span>{{ helper.title.comment_trade2 | translate }}</span>
                    </h4>
                    <textarea
                      type="text"
                      name="note_for_item"
                      [(ngModel)]="note_for_item"
                      class="form-control"
                      placeholder="{{
                        helper.placeholder.entrez_votre_comment | translate
                      }}"
                    >
                    </textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <div
        class="modal-footer-wrp d-flex align-items-center justify-content-center"
      >
        <div class="popup-footer-btn">
          <div
            class="qty-box d-flex align-items-center ml-auto"
            *ngIf="!edit_cart_item"
          >
            <button class="primary-btn dec" (click)="decrease_qty()">-</button>
            <input
              type="text"
              readonly=""
              value="{{ qty }}"
              class="form-control"
            />
            <button class="primary-btn inc" (click)="incerase_qty()">+</button>
          </div>
          <span
            class="missing_choice red"
            (click)="cart_service.go_to_missing_choice(current_item)"
            *ngIf="
              cart_service.get_missing_choice(
                current_item,
                current_formule.formule_id
              )
            "
            >{{
              cart_service.get_missing_choice(
                current_item,
                current_formule.formule_id
              )
            }}</span
          >
          <button
            *ngIf="!edit_cart_item"
            class="primary-btn"
            (click)="
              required_count !== required_temp_count
                ? cart_service.go_to_missing_choice(current_item)
                : handleClickOnAddToCart()
            "
            [class.disabled]="required_count !== required_temp_count"
          >
            <span
              class="p-price pro-strike-price"
              *ngIf="current_item.offer_price"
            >
              {{ delivery_currency }} {{ total }}
            </span>
            <span
              >{{ delivery_currency }}
              {{
                (
                  total -
                  (current_item.offer_price ? current_item.offer_price : 0)
                ).toFixed(2)
              }}</span
            >
            <span class="ml-auto"
              >{{ helper.button.ajouter | translate }}
              <label>
                <svg
                  width="13"
                  height="13"
                  viewBox="0 0 13 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="5.64771"
                    y="0.915436"
                    width="2.53521"
                    height="12"
                    rx="1.26761"
                  />
                  <rect
                    x="12.9154"
                    y="5.64786"
                    width="2.53521"
                    height="12"
                    rx="1.26761"
                    transform="rotate(90 12.9154 5.64786)"
                  />
                </svg>
              </label>
            </span>
          </button>
          <button
            *ngIf="edit_cart_item"
            class="primary-btn"
            (click)="updateCart()"
            [disabled]="required_count !== required_temp_count"
            [class.disabled]="required_count !== required_temp_count"
          >
            <span
              class="p-price pro-strike-price"
              *ngIf="current_item.offer_price"
            >
              {{ delivery_currency }} {{ total }}
            </span>
            <span
              >{{ delivery_currency }}
              {{
                (
                  total -
                  (current_item.offer_price ? current_item.offer_price : 0)
                ).toFixed(2)
              }}</span
            >
            <span class="ml-auto"
              >{{ helper.button.modifier | translate }}
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #ProductImagePreview let-modal>
  <div class="modal-main">
    <button
      type="button"
      class="close with-name pull-right d-flex align-items-center"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    >
      <span aria-hidden="true">
        <label>{{ helper.button.fermer | translate }}</label>
        <svg
          width="30"
          height="30"
          viewBox="0 0 30 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15 3C12.6266 3 10.3066 3.70379 8.33316 5.02236C6.35977 6.34094 4.8217 8.21508 3.91345 10.4078C3.0052 12.6005 2.76756 15.0133 3.23058 17.3411C3.6936 19.6689 4.83649 21.807 6.51472 23.4853C8.19295 25.1635 10.3311 26.3064 12.6589 26.7694C14.9867 27.2324 17.3995 26.9948 19.5922 26.0865C21.7849 25.1783 23.6591 23.6402 24.9776 21.6668C26.2962 19.6934 27 17.3734 27 15C27 13.4241 26.6896 11.8637 26.0866 10.4078C25.4835 8.95189 24.5996 7.62902 23.4853 6.51472C22.371 5.40041 21.0481 4.5165 19.5922 3.91345C18.1363 3.31039 16.5759 3 15 3ZM18.252 16.548C18.3645 16.6596 18.4538 16.7923 18.5147 16.9385C18.5756 17.0847 18.607 17.2416 18.607 17.4C18.607 17.5584 18.5756 17.7153 18.5147 17.8615C18.4538 18.0077 18.3645 18.1404 18.252 18.252C18.1404 18.3645 18.0077 18.4537 17.8615 18.5147C17.7153 18.5756 17.5584 18.607 17.4 18.607C17.2416 18.607 17.0847 18.5756 16.9385 18.5147C16.7923 18.4537 16.6596 18.3645 16.548 18.252L15 16.692L13.452 18.252C13.3404 18.3645 13.2077 18.4537 13.0615 18.5147C12.9153 18.5756 12.7584 18.607 12.6 18.607C12.4416 18.607 12.2847 18.5756 12.1385 18.5147C11.9923 18.4537 11.8596 18.3645 11.748 18.252C11.6355 18.1404 11.5463 18.0077 11.4853 17.8615C11.4244 17.7153 11.393 17.5584 11.393 17.4C11.393 17.2416 11.4244 17.0847 11.4853 16.9385C11.5463 16.7923 11.6355 16.6596 11.748 16.548L13.308 15L11.748 13.452C11.522 13.226 11.3951 12.9196 11.3951 12.6C11.3951 12.2804 11.522 11.974 11.748 11.748C11.974 11.522 12.2804 11.3951 12.6 11.3951C12.9196 11.3951 13.226 11.522 13.452 11.748L15 13.308L16.548 11.748C16.774 11.522 17.0804 11.3951 17.4 11.3951C17.7196 11.3951 18.026 11.522 18.252 11.748C18.478 11.974 18.6049 12.2804 18.6049 12.6C18.6049 12.9196 18.478 13.226 18.252 13.452L16.692 15L18.252 16.548Z"
          />
        </svg>
      </span>
    </button>
    <!-- <div class="modal-header justify-content-center no-header">

        </div> -->
    <div class="modal-body">
      <div class="modal-body-wrp">
        <div class="p-item-preview-img">
          <img
            src="{{
              current_item.image_url[0]
                ? helper.get_image(current_item.image_url[0])
                : helper.website_data.detail.site_logo
            }}"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- Product item popup end  -->
<app-delivery-error-modal #ScopeOfDelivery></app-delivery-error-modal>

<ng-template #ClearCart let-modal>
  <button
    type="button"
    class="close pull-right"
    aria-label="Close"
    (click)="modal.dismiss('Cross click')"
  >
    <span aria-hidden="true"
      ><svg
        width="14"
        height="15"
        viewBox="0 0 14 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.641964 4.44674C0.27079 4.07556 0.0852035 3.64252 0.0852036 3.14762C0.0852039 2.65272 0.270791 2.21969 0.641965 1.84851C1.01314 1.47734 1.43844 1.29948 1.91788 1.31495C2.39731 1.33042 2.82261 1.52374 3.19379 1.89491L12.6355 11.3367C13.0067 11.7078 13.1923 12.1409 13.1923 12.6358C13.2078 13.1152 13.0299 13.5405 12.6587 13.9117C12.2876 14.2829 11.8545 14.4684 11.3596 14.4684C10.8802 14.453 10.4549 14.2597 10.0837 13.8885L0.641964 4.44674ZM0.804354 13.6565C0.371317 13.2235 0.147065 12.7208 0.1316 12.1486C0.1316 11.5918 0.348119 11.0969 0.781156 10.6639L9.82853 1.61653C10.2616 1.18349 10.7642 0.974707 11.3364 0.990173C11.9087 1.00564 12.4113 1.22989 12.8443 1.66293C13.2928 2.11143 13.5093 2.60633 13.4939 3.14763C13.4939 3.70439 13.2774 4.19929 12.8443 4.63232L3.79695 13.6797C3.36391 14.1127 2.86901 14.3293 2.31225 14.3293C1.75549 14.3293 1.25286 14.105 0.804354 13.6565Z"
        />
      </svg>
    </span>
  </button>
  <div class="modal-header justify-content-center no-header">
    <h2>{{ helper.heading_title.clear_cart | translate }}</h2>
  </div>
  <div class="modal-body">
    <div class="modal-body-wrp text-center" style="margin-bottom: 30px">
      <p
        style="font-weight: bold; font-size: 20px"
        *ngIf="helper.common_data._user_cart.cart_data.is_catering"
      >
        Please Clear Catering Cart First
      </p>
      <p
        style="font-weight: bold; font-size: 20px"
        *ngIf="!helper.common_data._user_cart.cart_data.is_catering"
      >
        Please Clear Cart First
      </p>
    </div>
  </div>
  <div class="modal-footer">
    <div
      class="modal-footer-wrp d-flex align-items-center justify-content-center"
    >
      <div class="popup-footer-btn">
        <button class="primary-btn" (click)="clear_cart()">
          {{ helper.button.clear | translate }}
        </button>
      </div>
    </div>
  </div>
</ng-template>
